// @ts-nocheck
// NOTE: Ported from static/javascript/daily_deposit_list.ts as-is.
// Incremental typing TODO: replace @ts-nocheck above with real types over time.

(() => {
    const $ = (selector, root = document) => root.querySelector(selector);
    const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

    function loadTranslations() {
        const source = $('#translation-data');
        if (!source) return {};
        const data = source.dataset;
        return {
            justNow: data.justNow || '',
            minAgo: data.minAgo || '',
            hourAgo: data.hourAgo || '',
            hoursAgo: data.hoursAgo || '',
            yesterday: data.yesterday || '',
            daysAgo: data.daysAgo || '',
            weekAgo: data.weekAgo || '',
            weeksAgo: data.weeksAgo || '',
            monthAgo: data.monthAgo || '',
            monthsAgo: data.monthsAgo || '',
            yearAgo: data.yearAgo || '',
            yearsAgo: data.yearsAgo || '',
            pleaseEnterValidAmount: data.pleaseEnterValidAmount || '',
            durationInvalid: data.durationInvalid || '',
            calculating: data.calculating || '',
            unknownError: data.unknownError || '',
            error: data.error || '',
            customRateTitle: data.customRateTitle || '',
            customComparison: data.customComparison || '',
            customRateInvalid: data.customRateInvalid || '',
            daysLabel: data.daysLabel || '',
            annualRateLabel: data.annualRateLabel || '',
            withholdingRateLabel: data.withholdingRateLabel || '',
            netEarningLabel: data.netEarningLabel || '',
            netRateLabel: data.netRateLabel || '',
            netRateLower: data.netRateLower || 'net rate',
            grossRateLower: data.grossRateLower || 'gross rate',
            compoundLabel: data.compoundLabel || '',
            simpleLabel: data.simpleLabel || '',
            grossEarningLabel: data.grossEarningLabel || '',
            withholdingLabel: data.withholdingLabel || '',
            finalBalanceLabel: data.finalBalanceLabel || '',
            dailyGrossLabel: data.dailyGrossLabel || '',
            monthlyGrossLabel: data.monthlyGrossLabel || '',
            yearlyGrossLabel: data.yearlyGrossLabel || '',
            copySummaryLabel: data.copySummaryLabel || '',
            copiedLabel: data.copiedLabel || '',
            copyErrorLabel: data.copyErrorLabel || '',
            viewDetailsLabel: data.viewDetailsLabel || '',
			nameLabel: data.nameLabel || 'Name',
			principalLabel: data.principalLabel || '',
            startDateLabel: data.startDateLabel || 'Start Date',
            durationLabel: data.durationLabel || '',
            postingCountLabel: data.postingCountLabel || '',
            largestPostingLabel: data.largestPostingLabel || '',
            firstPostingLabel: data.firstPostingLabel || '',
            lastPostingLabel: data.lastPostingLabel || '',
            calcSnapshotLabel: data.calcSnapshotLabel || '',
            postingInsightsLabel: data.postingInsightsLabel || '',
            viewDetailsDisabled: data.viewDetailsDisabled || '',
            totalPostedLabel: data.totalPostedLabel || '',
            passiveBalanceLabel: data.passiveBalanceLabel || '',
            passiveRateLabel: data.passiveRateLabel || '',
            paybacksWeekend: data.paybacksWeekend || 'Paybacks on weekends and holidays',
            updated: data.updated || '',
            noDailyPostings: data.noDailyPostings || '',
            date: data.date || '',
            netPosting: data.netPosting || '',
            showAll: data.showAll || '',
            showLess: data.showLess || '',
            customRateBadge: data.customRateBadge || '',
            bankOfferBadge: data.bankOfferBadge || '',
            afterTax: data.afterTax || '',
            effectiveAnnualisedReturn: data.effectiveAnnualisedReturn || '',
            projectedClosingBalance: data.projectedClosingBalance || '',
            advertisedRate: data.advertisedRate || '',
            grossAnnualRate: data.grossAnnualRate || '',
            netAnnualRate: data.netAnnualRate || '',
            keepOverviewHandy: data.keepOverviewHandy || '',
            overview: data.overview || '',
            earnings: data.earnings || '',
            projections: data.projections || '',
            dailyPostings: data.dailyPostings || '',
            figuresEstimates: data.figuresEstimates || '',
            allRatesNet: data.allRatesNet || '',
            withholdingTax: data.withholdingTax || '',
            noCurrenciesAvailable: data.noCurrenciesAvailable || '',
            noInstitutionsAvailable: data.noInstitutionsAvailable || '',
            noProductsAvailable: data.noProductsAvailable || '',
            loadingOffers: data.loadingOffers || '',
            loadingMarketPerformance: data.loadingMarketPerformance || '',
            welcome: data.welcome || 'Welcome',
            remove: data.remove || 'Remove',
            noPerformanceData: data.noPerformanceData || '',
            noPerformanceDataCurrency: data.noPerformanceDataCurrency || '',
            showCalculationDetails: data.showCalculationDetails || '',
            changeVsLatestClose: data.changeVsLatestClose || '',
            baseLabel: data.baseLabel || 'Base',
            annualApprox: data.annualApprox || 'annual ≈',
            showingTopEntries: data.showingTopEntries || '',
            allCategoriesHidden: data.allCategoriesHidden || '',
        };
    }
    function replaceCountPlaceholder(template, value) {
        if (!template) return '';
        const strValue = String(value ?? '');
        return template
            .replace('%%(count)s', strValue)
            .replace('%(count)s', strValue);
    }

    function createModal(backdropId) {
        const backdrop = document.getElementById(backdropId);
        if (!backdrop) return null;
        const content = backdrop.querySelector('.modal-content');

		// Track global modal open count to manage scroll locking
		if (typeof window.__openModalCount === 'undefined') {
			window.__openModalCount = 0;
		}

		const lockScroll = () => {
			try {
				document.documentElement.style.overflow = 'hidden';
				document.body.style.overflow = 'hidden';
			} catch (_) {}
		};

		const unlockScroll = () => {
			try {
				if (window.__openModalCount <= 0) {
					document.documentElement.style.overflow = '';
					document.body.style.overflow = '';
				}
			} catch (_) {}
		};

        document.body.appendChild(backdrop);

        let isVisible = false;

		const show = () => {
            if (isVisible) return;
            isVisible = true;
            backdrop.classList.remove('hidden');
			window.__openModalCount += 1;
			lockScroll();
            // Reset scroll position to top when opening modal
            // Reset the main modal content
            if (content) {
                content.scrollTop = 0;
            }
            // Reset scroll for any scrollable elements inside the modal
            // This includes elements with overflow-y-auto class or style
            const scrollableElements = backdrop.querySelectorAll('.overflow-y-auto, [style*="overflow-y-auto"], #details-modal-content, #modal-body');
            scrollableElements.forEach(el => {
                try {
                    if (el && typeof el.scrollTop !== 'undefined') {
                        el.scrollTop = 0;
                    }
                } catch (e) {
                    // Ignore errors for elements that can't be scrolled
                }
            });
            requestAnimationFrame(() => {
                backdrop.style.opacity = '1';
                if (content) {
                    content.style.opacity = '1';
                    content.style.transform = 'translateY(0)';
                }
            });
        };

		const hide = () => {
            if (!isVisible) return;
            isVisible = false;
            backdrop.style.opacity = '0';
            if (content) {
                content.style.opacity = '0';
                content.style.transform = 'translateY(-2.5rem)';
            }
            setTimeout(() => {
                if (!isVisible) {
                    backdrop.classList.add('hidden');
                }
				// After animation ends, decrease counter and possibly unlock scroll
				window.__openModalCount = Math.max(0, (window.__openModalCount || 0) - 1);
				unlockScroll();
			}, 300);
        };

        backdrop.addEventListener('click', event => {
            if (event.target === backdrop) hide();
        });

        return { backdrop, show, hide };
    }

    let initialized = false;

    const init = () => {
        if (initialized) return;
        initialized = true;

        const trans = loadTranslations();
        const MEDIA_BASE_URL_RAW = window.BOZON_MEDIA_URL || '/media/';
        const MEDIA_BASE_URL = MEDIA_BASE_URL_RAW.endsWith('/') ? MEDIA_BASE_URL_RAW : `${MEDIA_BASE_URL_RAW}/`;
        const buildMediaUrl = (path) => {
            if (!path) return null;
            const trimmed = String(path).trim();
            if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('/')) {
                return trimmed;
            }
            return `${MEDIA_BASE_URL}${trimmed.replace(/^\/+/, '')}`;
        };
        const supportedPageLanguages = new Set(['tr', 'en']);
        const getPageLanguage = () => {
            const htmlLang = (document.documentElement.lang || '').split('-', 1)[0].toLowerCase();
            if (htmlLang) return htmlLang;

            const firstPathSegment = (window.location.pathname || '')
                .split('/')
                .filter(Boolean)[0];
            return (firstPathSegment || '').toLowerCase();
        };
        const normalizeDailyDepositDetailUrl = (url) => {
            if (!url || url === '#') return url;

            const pageLang = getPageLanguage();
            if (!pageLang) return url;

            try {
                const parsed = new URL(String(url), window.location.origin);
                if (parsed.origin !== window.location.origin) return String(url);

                const segments = parsed.pathname.split('/').filter(Boolean);
                const bankingIndex = segments.indexOf('banking');
                const isDailyDepositDetail =
                    bankingIndex !== -1 && segments[bankingIndex + 1] === 'daily-deposit';

                if (!isDailyDepositDetail) {
                    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
                }

                if (segments[0] === pageLang) {
                    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
                }

                if (supportedPageLanguages.has(segments[0])) {
                    segments[0] = pageLang;
                } else if (bankingIndex === 0) {
                    segments.unshift(pageLang);
                } else {
                    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
                }

                const trailingSlash = parsed.pathname.endsWith('/') ? '/' : '';
                return `/${segments.join('/')}${trailingSlash}${parsed.search}${parsed.hash}`;
            } catch (_) {
                const trimmed = String(url).replace(/^\/+/, '');
                if (trimmed.startsWith('banking/daily-deposit/')) {
                    return `/${pageLang}/${trimmed}`;
                }
                return url;
            }
        };
        const translationSource = $('#translation-data');
        const CUSTOM_LOGO_URL =
            buildMediaUrl(translationSource?.dataset.customLogoUrl || 'images/banking/banks/custom.svg') ||
            '/media/images/banking/banks/custom.svg';
        const noStoreFetchOptions = {
            cache: 'no-store',
            headers: {
                'Cache-Control': 'no-cache',
            },
        };
        const dom = {
            grid: $('#accounts-grid'),
            staleSection: $('#stale-accounts-section'),
            staleGrid: $('#stale-accounts-grid'),
            calculatorForm: $('#calculator-form'),
            amountInput: $('#amount'),
            amountHidden: $('#amount-hidden'),
            durationInput: $('#duration'),
            startDateInput: $('#start-date'),
            calculatorError: $('#calculator-error'),
            calculatorCurrencySymbol: $('#calculator-currency-symbol'),
            settingsButton: $('#settings-btn'),
            settingsClose: $('#settings-close-btn'),
            settingsApply: $('#settings-apply-btn'),
            settingsClear: $('#settings-clear-btn'),
            compoundCheckbox: $('#filter-compound'),
            activeFilterCount: $('#active-filter-count'),
            disclaimerButton: $('#calculate-btn'),
            clearCalculationButton: $('#clear-calculation-btn'),
            disclaimerClose: $('#disclaimer-close-btn'),
            disclaimerCancel: $('#disclaimer-cancel'),
            disclaimerAccept: $('#disclaimer-accept'),
            detailsClose: $('#modal-close-btn'),
            modalTitle: $('#details-title'),
            modalBody: $('#modal-body'),
            bankFilterButton: $('#bank-filter-btn'),
            bankFilterClose: $('#bank-filter-close-btn'),
            bankFilterCount: $('#bank-filter-count'),
            bankFilterSearch: $('#bank-filter-search'),
            bankFilterSelectAll: $('#bank-filter-select-all'),
            bankFilterDeselectAll: $('#bank-filter-deselect-all'),
            bankFilterClear: $('#bank-filter-clear-btn'),
            bankFilterApply: $('#bank-filter-apply-btn'),
            bankFilterEmpty: $('#bank-filter-empty'),
            customRateButton: $('#custom-rate-btn'),
            customRateClose: $('#custom-rate-close-btn'),
            customRateApply: $('#custom-rate-apply-btn'),
            customRateClear: $('#custom-rate-clear-btn'),
            customRateIndicator: $('#custom-rate-indicator'),
            customRateName: $('#custom-rate-name'),
            customRateValue: $('#custom-rate-value'),
            customRatePassive: $('#custom-rate-passive'),
            customRatePassiveRate: $('#custom-rate-passive-rate'),
            customRateWeekend: $('#custom-rate-weekend'),
            customRateList: $('#custom-rate-list'),
            customRateAdd: $('#custom-rate-add'),
            customRateTabs: $('#custom-rate-tabs'),
            assetPerformanceBlock: $('#asset-performance-block'),
            rateDisplaySelect: $('#rate-display-select'),
        };


        const currencyButtons = $$('.currency-btn');
        let bankCheckboxes = $$('.bank-filter-checkbox');
        const assetSections = $$('.asset-performance-section');
        const assetWrappers = $$('.asset-performance-wrapper');
        let cards = [];
        let allBankSlugs = new Set();
        let totalBankCount = 0;

        const filterCheckboxes = {
            compound: dom.compoundCheckbox,
            welcome: $('#filter-welcome-offers'),
            young: $('#filter-young-offers'),
            plus: $('#filter-plus-offers'),
        };

        const assetCheckboxes = {
            currencies: $('#filter-asset-currencies'),
            commodities: $('#filter-asset-commodities'),
            cryptocurrencies: $('#filter-asset-cryptocurrencies'),
        };

            const modals = {
            settings: createModal('settings-modal'),
            disclaimer: createModal('disclaimer-modal'),
            details: createModal('details-modal'),
            bankFilter: createModal('bank-filter-modal'),
            customRate: createModal('custom-rate-modal'),
        };

        const defaultFilters = { compound: true, welcome: true, young: true, plus: true, rateDisplay: 'net' };
        const defaultAssetVisibility = { currencies: true, commodities: true, cryptocurrencies: true };

        const detailCache = new Map();

        const state = {
            currency: '',
            filters: { ...defaultFilters },
            selectedBanks: new Set(),
            customRate: null,
            customRates: [],
            assetVisibility: { ...defaultAssetVisibility },
            detailEndpoints: new Map(),
            lastCalculationPayload: null,
        };

        // --- Persistence helpers ---
        const STORAGE_KEY = 'daily_deposit_prefs_v1';
        function saveStateToStorage() {
            try {
                const payload = {
                    currency: state.currency,
                    filters: state.filters,
                    selectedBanks: Array.from(state.selectedBanks || []),
                    customRate: state.customRate,
                    customRates: state.customRates,
                    assetVisibility: state.assetVisibility,
                    amount: getAmountValue(),
                    duration: dom.durationInput ? dom.durationInput.value : undefined,
                    startDate: dom.startDateInput ? dom.startDateInput.value : undefined,
                };
                localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
            } catch (_) {}
        }
        function loadStateFromStorage() {
            try {
                const raw = localStorage.getItem(STORAGE_KEY);
                if (!raw) return;
                const obj = JSON.parse(raw);
                if (obj && typeof obj === 'object') {
                    if (obj.currency) state.currency = obj.currency;
                    if (obj.filters) state.filters = { ...defaultFilters, ...obj.filters };
                    if (Array.isArray(obj.selectedBanks)) state.selectedBanks = new Set(obj.selectedBanks);
                    if (obj.customRate) state.customRate = obj.customRate;
                    if (Array.isArray(obj.customRates)) state.customRates = obj.customRates;
                    if (obj.assetVisibility) state.assetVisibility = { ...defaultAssetVisibility, ...obj.assetVisibility };
                    if (dom.amountInput && dom.amountHidden && Number.isFinite(obj.amount)) {
                        dom.amountInput.value = formatNumberWithCommas(obj.amount);
                        dom.amountHidden.value = String(obj.amount);
                    }
                    if (dom.durationInput && obj.duration) {
                        dom.durationInput.value = String(obj.duration);
                    }
                    if (dom.startDateInput && obj.startDate) {
                        dom.startDateInput.value = String(obj.startDate);
                    }
                }
            } catch (_) {}
        }

        const currencyMap = {};
        const currencyFilterContainer = $('#currency-filter-container');
        const initialCurrency = currencyFilterContainer ? (currencyFilterContainer.dataset.initialCurrency || '') : '';
        state.currency = initialCurrency || 'TRY';
        updateTaxWarning();
        loadStateFromStorage();
        function getLocalDateInputValue(dateValue = new Date()) {
            const dateObj = dateValue instanceof Date ? dateValue : new Date(dateValue);
            if (Number.isNaN(dateObj.getTime())) return '';
            const localDate = new Date(dateObj.getTime() - dateObj.getTimezoneOffset() * 60000);
            return localDate.toISOString().slice(0, 10);
        }
        function isValidDateInputValue(value) {
            return /^\d{4}-\d{2}-\d{2}$/.test(String(value || ''));
        }
        function getSelectedStartDate() {
            if (dom.startDateInput && isValidDateInputValue(dom.startDateInput.value)) {
                return dom.startDateInput.value;
            }
            return getLocalDateInputValue();
        }
        if (dom.startDateInput) {
            if (!isValidDateInputValue(dom.startDateInput.value)) {
                dom.startDateInput.value = getLocalDateInputValue();
            }
            dom.startDateInput.addEventListener('change', saveStateToStorage);
        }
        if (filterCheckboxes.compound) {
            filterCheckboxes.compound.checked = !!state.filters.compound;
        }

        function refreshCards() {
            const cardRoots = [dom.grid, dom.staleGrid].filter(Boolean);
            cards = cardRoots.flatMap(root => $$('.account-card', root));
            allBankSlugs = new Set();
            cards.forEach(card => {
                const slug = card.dataset.bankSlug;
                if (slug && slug !== 'custom') {
                    allBankSlugs.add(slug);
                }
            });
            totalBankCount = allBankSlugs.size;
        }

        function formatPercent(value, decimals = 1) {
            if (value === null || value === undefined) return '—';
            const num = parseFloat(value);
            if (!Number.isFinite(num)) return '—';
            const locale = document.documentElement.lang || navigator.language || 'en-US';
            // Check if number is effectively an integer (within precision tolerance)
            const rounded = Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
            const isInteger = Math.abs(rounded - Math.round(rounded)) < 0.0001;
            
            if (isInteger) {
                // Format as integer (no decimals)
                return num.toLocaleString(locale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }) + '%';
            } else {
                // Format with decimals
                return num.toLocaleString(locale, {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                }) + '%';
            }
        }

        async function fetchOffers(currencyCode) {
            if (!dom.grid) return null;
            const apiUrl = dom.grid.dataset.apiUrl;
            if (!apiUrl) return null;

            try {
                const url = `${apiUrl}?currency=${encodeURIComponent(currencyCode || 'TRY')}&coverage=web_home`;
                const response = await fetch(url, noStoreFetchOptions);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const json = await response.json();
                if (json.success && json.data && json.data.offers) {
                    return json.data.offers;
                }
                return null;
            } catch (error) {
                return null;
            }
        }

        function renderOfferCard(offer) {
            const bank = offer.bank || {};
            const product = offer.product || {};
            const currency = offer.currency || {};
            const color = bank.color || '#2e1818';
            const hasColor = !!bank.color;
            const logoPath = bank.logo_path || '';
            const detailUrl = normalizeDailyDepositDetailUrl(offer.detail_url) || '#';
            const netMinRate = offer.net_min_rate;
            const netMaxRate = offer.net_max_rate;
            const minRate = offer.min_rate || 0;
            const maxRate = offer.max_rate || 0;
            const isStandard = offer.is_standard_offer || false;
            const isWelcome = offer.is_welcome_offer || false;
            const isSimpleWelcome = offer.is_simple_welcome_offer || false;
            const offerName = (offer.translated_offer_name || offer.offer_name || '');
            const lastUpdated = bank.last_successful_update || '';

            const logoUrl = logoPath ? buildMediaUrl(logoPath) : '';
            const logoHtml = logoUrl 
                ? `<img src="${logoUrl}" alt="${bank.name || ''}" class="h-full w-full object-contain" loading="lazy" decoding="async" width="80" height="40">`
                : `<div class="flex h-16 w-16 items-center justify-center rounded-full bg-brand-primary text-white text-lg font-bold">${(bank.name || '').charAt(0) || '?'}</div>`;

            // Build locale-aware uppercase only for "Welcome | ..."; keep plain "Welcome" as-is
            const pageLocale = (document.documentElement.lang || navigator.language || 'en-US');
            const toUpperForLocale = (str) => {
                if (!str) return '';
                return pageLocale.toLowerCase().startsWith('tr')
                    ? str.toLocaleUpperCase('tr-TR')
                    : str.toLocaleUpperCase('en-US');
            };
            let badgeText;
            if (isSimpleWelcome) {
                badgeText = toUpperForLocale(trans.welcome || 'Welcome');
            } else if ((offerName || '').includes('|')) {
                const parts = (offerName || '').split('|');
                const left = (parts[0] || '').trim();
                const right = (parts.slice(1).join('|') || '').trim();
                const leftLabel = left.toLowerCase() === 'welcome' ? (trans.welcome || left) : left;
                const leftUpper = toUpperForLocale(leftLabel);
                const rightUpper = toUpperForLocale(right);
                badgeText = rightUpper ? `${leftUpper} | ${rightUpper}` : leftUpper;
            } else {
                badgeText = toUpperForLocale(offerName || '');
            }
            const offerBadgeHtml = !isStandard
                ? `<span class="offer-badge inline-flex items-center gap-1 px-2 py-1 text-[9px] font-bold tracking-wide rounded-full border shadow-sm shadow-black/5 transition-transform duration-200 group-hover:scale-105 leading-tight max-w-[100px] text-center whitespace-nowrap overflow-hidden text-ellipsis" style="color: ${color}; background-color: ${color}15; border-color: ${color}50; box-shadow: 0 6px 16px ${color}20;" title="${badgeText}"><span>${badgeText}</span></span>`
                : '';

            const netRateDisplay = netMinRate === netMaxRate
                ? formatPercent(netMinRate, 1)
                : `${formatPercent(netMinRate, 1)} - ${formatPercent(netMaxRate, 1)}`;

            const grossRateDisplay = minRate === maxRate
                ? `${formatPercent(minRate, 1)} ${trans.grossRateLower}`
                : `${formatPercent(minRate, 1)} - ${formatPercent(maxRate, 1)} ${trans.grossRateLower}`;

            const netRateFullDisplay = netMinRate === netMaxRate
                ? `${formatPercent(netMinRate, 1)} ${trans.netRateLower}`
                : `${formatPercent(netMinRate, 1)} - ${formatPercent(netMaxRate, 1)} ${trans.netRateLower}`;

            const updateDateAttr = lastUpdated ? `data-update-date="${lastUpdated}"` : '';
            const updateDate = lastUpdated ? new Date(lastUpdated) : null;
            const isStale = updateDate ? isStaleUpdate(updateDate) : false;

            let primaryRateNumbers = '';
            let primaryRateLabel = '';

            if (state.filters.rateDisplay === 'gross') {
                primaryRateNumbers = minRate === maxRate
                    ? formatPercent(minRate, 1)
                    : `${formatPercent(minRate, 1)} - ${formatPercent(maxRate, 1)}`;
                primaryRateLabel = trans.grossRateLower;
            } else if (state.filters.rateDisplay === 'advertised') {
                const advRate = offer.advertised_rate || maxRate;
                primaryRateNumbers = formatPercent(advRate, 1);
                primaryRateLabel = trans.advertisedRate || 'Advertised Rate';
            } else {
                primaryRateNumbers = netMinRate === netMaxRate
                    ? formatPercent(netMinRate, 1)
                    : `${formatPercent(netMinRate, 1)} - ${formatPercent(netMaxRate, 1)}`;
                primaryRateLabel = trans.netRateLower;
            }

            const isGrossPrimary = state.filters.rateDisplay === 'gross';
            const initialGrossClass = isGrossPrimary ? 'hidden' : '';
            const initialNetClass = isGrossPrimary ? '' : 'hidden';

            const cardHtml = `
                <div class="account-card flex flex-col bg-white rounded-xl sm:rounded-2xl border border-gray-200 sm:border-2 hover:shadow-lg transition-all duration-300 overflow-hidden group hover:scale-105 relative" 
                     data-offer-id="${offer.id}"
                     data-name="${bank.name || ''}"
                     data-rate="${maxRate}"
                     data-bank-slug="${bank.slug || ''}"
                     data-currency="${currency.code || ''}"
                     data-welcome="${isWelcome}"
                     data-young="${offer.is_young_offer || false}"
                     data-plus="${offer.is_plus_offer || false}"
                     data-min-rate="${minRate}"
                     data-max-rate="${maxRate}"
                     data-net-min-rate="${netMinRate || ''}"
                     data-net-max-rate="${netMaxRate || ''}"
                     data-stale-update="${isStale ? 'true' : 'false'}"
                     ${updateDateAttr ? updateDateAttr + ' ' : ''}
                     style="border-color: ${color};">
                    <a href="${detailUrl}" class="block group-hover:opacity-90 transition-opacity duration-200">
                        <div class="px-3 py-2" style="background: linear-gradient(135deg, ${color}20 0%, ${color}10 100%);">
                            <div class="flex items-center justify-between gap-1">
                                <div class="flex items-center gap-1">
                                    <div class="flex h-10 w-20 flex-shrink-0 items-center justify-center">
                                        ${logoHtml}
                                    </div>
                                    ${offerBadgeHtml}
                                </div>
                                <svg class="w-4 h-4 transition-colors flex-shrink-0" style="color: ${color};" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                                </svg>
                            </div>
                        </div>
                    </a>
                    <div class="card-content p-3 flex flex-col items-center flex-grow gap-2">
                        <div class="space-y-1.5 w-full">
                            <h3 class="text-[11px] font-semibold text-gray-900 leading-tight line-clamp-2 text-center" title="${product.name || ''}">${product.name || ''}</h3>
                            <div class="annual-rate-block flex flex-col items-center justify-center text-center space-y-0.5 w-full">
                                <div class="text-xl sm:text-2xl font-bold whitespace-nowrap" style="color: ${color};">
                                    ${primaryRateNumbers}
                                </div>
                                <div class="default-update text-[10px] text-gray-500 leading-tight uppercase">${primaryRateLabel}</div>
                            </div>
                        </div>
                        <div class="calculation-block mt-1.5">
                            <div class="calculation-result-btn hidden rounded-lg px-2 py-1.5 cursor-pointer hover:opacity-90 transition-all duration-200" style="background-color: ${color}20; color: ${color};" aria-label="${trans.showCalculationDetails || 'Show calculation details'}">
                                <div class="relative flex items-center w-full">
                                    <div class="flex-1 text-center pointer-events-none">
                                        <div class="text-[10px] font-medium mb-0.5">${trans.netEarningLabel}</div>
                                        <div class="text-sm sm:text-base font-bold mb-0.5 net-earning-val">-</div>
                                        <div class="text-[10px] font-medium mb-0.5">${trans.netRateLabel}</div>
                                        <div class="text-xs sm:text-sm font-semibold net-rate-val">-</div>
                                    </div>
                                    <div class="absolute right-1.5 top-1/2 -translate-y-1/2" aria-hidden="true">
                                        <svg class="w-4 h-4" style="color: ${color};" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="-mt-1 pt-0 border-t border-gray-100 text-center space-y-0.5">
                            <div class="gross-rate-display ${initialGrossClass} text-[10px] text-gray-400 leading-tight">
                                ${grossRateDisplay}
                            </div>
                            <div class="net-rate-display ${initialNetClass} text-[10px] text-gray-400 leading-tight">
                                ${netRateFullDisplay}
                            </div>
                            <div class="default-update text-[10px] text-gray-400 leading-tight">
                                ${lastUpdated ? `<span class="relative-time" data-update-date="${lastUpdated}"></span>` : ''}
                            </div>
                        </div>
                    </div>
                </div>
            `;
            return cardHtml;
        }

        async function fetchCurrencies() {
            const container = $('#currency-filter-container');
            if (!container) return null;
            const apiUrl = container.dataset.apiUrl;
            if (!apiUrl) return null;

            try {
                const url = `${apiUrl}?account_type=daily_deposit`;
                const response = await fetch(url, noStoreFetchOptions);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const json = await response.json();
                if (json.success && json.data && json.data.currencies) {
                    return json.data.currencies;
                }
                return null;
            } catch (error) {
                return null;
            }
        }

        function renderCurrencyButtons(currencies) {
            const container = $('#currency-filter-container');
            if (!container) return;

            if (!currencies || currencies.length === 0) {
                container.innerHTML = `<div class="text-center py-2"><p class="text-sm text-gray-500">${trans.noCurrenciesAvailable}</p></div>`;
                return;
            }

            let html = '';
            const currentCurrency = state.currency.toUpperCase();
            currencies.forEach(currency => {
                const code = (currency.code || '').toUpperCase();
                const isActive = code === currentCurrency;
                html += `
                    <button
                        data-currency="${code}"
                        class="currency-btn flex-shrink-0 px-4 py-2 text-sm font-medium rounded-xl hover:bg-gray-50 hover:border-brand-accent focus:outline-none focus:ring-2 focus:ring-brand-accent transition-all duration-200 border ${isActive ? 'bg-brand-primary text-white border-brand-primary hover:bg-opacity-90' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'}"
                        type="button"
                        role="tab"
                        aria-selected="${isActive}"
                    >
                        ${code}
                    </button>
                `;
                
                // Build currency map for symbol lookup
                currencyMap[code] = {
                    symbol: currency.symbol || null,
                    code: code,
                    name: currency.name || code,
                };
            });

            container.innerHTML = html;
            
            // Refresh currency buttons reference
            currencyButtons.length = 0;
            currencyButtons.push(...$$('.currency-btn'));
            
            // Attach event listeners to currency buttons
            currencyButtons.forEach(button => {
                button.addEventListener('click', () => setCurrency(button.dataset.currency));
            });
            
            // Update scroll buttons
            updateCurrencyScrollButtons();
            updateMarketPerformanceTitle(marketPerformanceDefaultBase || state.currency);
        }

        async function loadCurrencies() {
            const currencies = await fetchCurrencies();
            renderCurrencyButtons(currencies);
            updateCurrencySymbol();
        }

        async function fetchBanks() {
            const button = $('#bank-filter-btn');
            if (!button) return null;
            const apiUrl = button.dataset.apiUrl;
            if (!apiUrl) return null;

            try {
                const url = `${apiUrl}?account_type=daily_deposit`;
                const response = await fetch(url, noStoreFetchOptions);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const json = await response.json();
                if (json.success && json.data && json.data.banks) {
                    return json.data.banks;
                }
                return null;
            } catch (error) {
                return null;
            }
        }

        function renderBankList(banks) {
            const listContainer = $('#bank-filter-list');
            if (!listContainer) return;

            if (!banks || banks.length === 0) {
                listContainer.innerHTML = `<div class="col-span-full text-center py-6"><p class="text-sm text-gray-500">${trans.noInstitutionsAvailable}</p></div>`;
                // Hide bank filter button if no banks
                if (dom.bankFilterButton) {
                    dom.bankFilterButton.classList.add('hidden');
                }
                return;
            }

            let html = '';
            banks.forEach(bank => {
                const bankSlug = bank.slug || '';
                const bankName = bank.name || '';
                const logoPath = bank.logo_path || '';
                const logoUrl = logoPath ? buildMediaUrl(logoPath) : '';
                const isChecked = state.selectedBanks.size === 0 || state.selectedBanks.has(bankSlug);
                
                html += `
                    <label class="group flex items-center gap-3 border border-gray-200 rounded-xl p-3 hover:border-brand-accent transition-colors">
                        <input type="checkbox" class="bank-filter-checkbox h-4 w-4 text-brand-primary border-gray-300 rounded focus:ring-brand-accent" data-bank-slug="${bankSlug}" data-bank-name="${bankName.toLowerCase()}" value="${bankSlug}" ${isChecked ? 'checked' : ''}>
                        <div class="flex items-center gap-3">
                            ${logoUrl ? `<img src="${logoUrl}" alt="${bankName}" class="w-20 object-contain rounded-md bg-white border border-gray-100" loading="lazy" decoding="async" width="32" height="32">` : `<div class="h-8 w-8 flex items-center justify-center rounded-md bg-brand-primary text-white font-semibold">${bankName.charAt(0)}</div>`}
                            <span class="text-sm font-medium text-gray-700 group-hover:text-brand-primary transition-colors truncate">${bankName}</span>
                        </div>
                    </label>
                `;
            });

            listContainer.innerHTML = html;
            
            // Refresh bank checkboxes reference
            bankCheckboxes = $$('.bank-filter-checkbox');
            
            // Update total bank count
            allBankSlugs = new Set(banks.map(b => b.slug || '').filter(Boolean));
            totalBankCount = allBankSlugs.size;
            
            // Show bank filter button if banks exist
            if (dom.bankFilterButton && banks.length > 0) {
                dom.bankFilterButton.classList.remove('hidden');
            }
        }

        async function loadBanks() {
            const banks = await fetchBanks();
            renderBankList(banks);
        }

        async function fetchStatistics() {
            const section = $('#statistics-section');
            if (!section) return null;
            const apiUrl = section.dataset.apiUrl;
            if (!apiUrl) return null;

            try {
                const url = `${apiUrl}?account_type=daily_deposit`;
                const response = await fetch(url, noStoreFetchOptions);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const json = await response.json();
                if (json.success && json.data) {
                    return json.data;
                }
                return null;
            } catch (error) {
                return null;
            }
        }

        function renderStatistics(stats) {
            const section = $('#statistics-section');
            if (!section || !stats) return;

            const bankCountEl = $('#stat-bank-count');
            const productCountEl = $('#stat-product-count');
            const offerCountEl = $('#stat-offer-count');
            const calculationsEl = $('#stat-calculations');

            if (bankCountEl) {
                bankCountEl.textContent = formatNumberWithCommas(stats.bank_count || 0);
            }
            if (productCountEl) {
                productCountEl.textContent = formatNumberWithCommas(stats.product_count || 0);
            }
            if (offerCountEl) {
                offerCountEl.textContent = formatNumberWithCommas(stats.offer_count || 0);
            }
            if (calculationsEl) {
                calculationsEl.textContent = formatNumberWithCommas(stats.total_calculations || 0);
            }

            // Show the statistics section
            section.classList.remove('hidden');
        }

        async function loadStatistics() {
            const stats = await fetchStatistics();
            renderStatistics(stats);
        }

        async function loadOffers() {
            if (!dom.grid) return;
            
            // Show loading state
            dom.grid.innerHTML = `<div class="col-span-full text-center py-8"><p class="text-sm text-gray-500">${trans.loadingOffers}</p></div>`;
            if (dom.staleGrid) dom.staleGrid.innerHTML = '';
            syncStaleSectionVisibility();
            
            const offers = await fetchOffers(state.currency);
            
            if (!offers || offers.length === 0) {
                dom.grid.innerHTML = `<div class="col-span-full text-center py-8 bg-white rounded-lg shadow"><p class="text-sm text-gray-600">${trans.noProductsAvailable}</p></div>`;
                if (dom.staleGrid) dom.staleGrid.innerHTML = '';
                refreshCards();
                applyFilters();
                return;
            }

            // Sort offers by max_rate_sort (already sorted by API, but ensure consistency)
            offers.sort((a, b) => (b.max_rate_sort || 0) - (a.max_rate_sort || 0));

            // Render all offers
            let html = '';
            offers.forEach(offer => {
                html += renderOfferCard(offer);
            });
            
            dom.grid.innerHTML = html;
            refreshCards();
            applyFilters();
            sortCardsByRate();
            updateRelativeTimes();
        }

        function getLocale() {
            return document.documentElement.lang || navigator.language || 'en-US';
        }
        
        function usesCommaDecimal() {
            const locale = getLocale();
            const testNumber = 1234.56;
            const formatted = new Intl.NumberFormat(locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(testNumber);
            return /,\d/.test(formatted);
        }
        
        function formatNumberWithCommas(value) {
            if (!value && value !== 0) return '';
            
            const numValue = parseInt(value, 10);
            if (!Number.isFinite(numValue)) return '';
            
            const locale = getLocale();
            const formatter = new Intl.NumberFormat(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                useGrouping: true
            });
            
            return formatter.format(numValue);
        }

        function getNumericValue(value) {
            if (!value) return '';
            
            const locale = getLocale();
            const usesComma = usesCommaDecimal();
            let cleaned = value.toString().trim();
            if (usesComma) {
                cleaned = cleaned.replace(/\./g, '').replace(/,/g, '');
            } else {
                cleaned = cleaned.replace(/,/g, '').replace(/\./g, '');
            }
            cleaned = cleaned.replace(/[^\d]/g, '');
            
            return cleaned;
        }

        function getCsrfToken() {
            const csrfTokenInput = $('[name=csrfmiddlewaretoken]', dom.calculatorForm);
            return csrfTokenInput ? csrfTokenInput.value : null;
        }

        function buildJsonHeaders() {
            const headers = {
                'Content-Type': 'application/json',
            };
            const csrfToken = getCsrfToken();
            if (csrfToken) {
                headers['X-CSRFToken'] = csrfToken;
            }
            return headers;
        }

        function getApiErrorMessage(data, fallback) {
            if (!data) return fallback;
            if (typeof data.error === 'string' && data.error.trim()) return data.error;
            if (typeof data.message === 'string' && data.message.trim()) return data.message;
            if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;
            if (Array.isArray(data.detail)) {
                const messages = data.detail
                    .map(item => {
                        if (!item) return '';
                        if (typeof item === 'string') return item;
                        if (typeof item.msg === 'string' && item.msg.trim()) return item.msg;
                        if (typeof item.message === 'string' && item.message.trim()) return item.message;
                        return '';
                    })
                    .filter(Boolean);
                if (messages.length) return messages.join(' ');
            }
            return fallback;
        }

        function getAmountValue() {
            if (!dom.amountHidden && !dom.amountInput) return null;
            const raw = dom.amountHidden
                ? dom.amountHidden.value
                : getNumericValue(dom.amountInput.value || '');
            if (!raw) {
                return null;
            }
            const numeric = parseInt(raw, 10);
            return Number.isFinite(numeric) ? numeric : null;
        }

        // Initialize default values
        if (dom.amountInput && dom.amountHidden) {
            const defaultAmountNumeric = parseInt(dom.amountInput.dataset.default || '900000', 10);
            const defaultAmountFormatted = formatNumberWithCommas(defaultAmountNumeric);
            let previousAmount = defaultAmountFormatted;
            
            // Set initial display and hidden values if input is empty
            if (!dom.amountInput.value || dom.amountInput.value.trim() === '') {
                dom.amountInput.value = defaultAmountFormatted;
            } else {
                // Format existing value
                const existingNumeric = getNumericValue(dom.amountInput.value);
                if (existingNumeric) {
                    dom.amountInput.value = formatNumberWithCommas(parseInt(existingNumeric, 10));
                }
            }
            // Always set hidden value from current display value
            const currentNumeric = getNumericValue(dom.amountInput.value);
            dom.amountHidden.value = currentNumeric ? parseInt(currentNumeric, 10) : defaultAmountNumeric;
            
            dom.amountInput.addEventListener('focus', function(e) {
                previousAmount = e.target.value;
                // Clear input value every time on focus
                e.target.value = '';
                dom.amountHidden.value = '';
            });
            
            dom.amountInput.addEventListener('blur', function(e) {
                const numericValue = getNumericValue(e.target.value);
                if (!numericValue || numericValue === '') {
                    // Restore previous value if user didn't enter anything valid
                    if (previousAmount) {
                        e.target.value = previousAmount;
                        dom.amountHidden.value = parseInt(getNumericValue(previousAmount), 10) || defaultAmountNumeric;
                    } else {
                        e.target.value = defaultAmountFormatted;
                        dom.amountHidden.value = defaultAmountNumeric;
                    }
                } else {
                    // Format the value properly with locale-aware formatting
                    const numVal = parseInt(numericValue, 10);
                    if (Number.isFinite(numVal)) {
                        e.target.value = formatNumberWithCommas(numVal);
                        dom.amountHidden.value = numVal;
                        previousAmount = e.target.value;
                    } else {
                        // Invalid number, restore previous
                        e.target.value = previousAmount || defaultAmountFormatted;
                        dom.amountHidden.value = parseInt(getNumericValue(previousAmount), 10) || defaultAmountNumeric;
                    }
                }
                saveStateToStorage();
            });
        }
        
        if (dom.durationInput) {
			// Basic numeric-only hints
			dom.durationInput.setAttribute('inputmode', 'numeric');
			dom.durationInput.setAttribute('pattern', '[0-9]*');
			if (!dom.durationInput.hasAttribute('step')) dom.durationInput.setAttribute('step', '1');
			if (!dom.durationInput.hasAttribute('min')) dom.durationInput.setAttribute('min', '1');
            const defaultDuration = dom.durationInput.dataset.default || '1';
            const maxDuration = parseFloat(dom.durationInput.dataset.max || '700');
            let previousDuration = defaultDuration;
            
            dom.durationInput.addEventListener('focus', function(e) {
                // Store previous and clear on focus like amount box
                previousDuration = e.target.value;
                e.target.value = '';
            });
            
			dom.durationInput.addEventListener('input', function(e) {
				// Keep only digits
				const rawDigits = (e.target.value || '').replace(/\D+/g, '');
				e.target.value = rawDigits;
				let value = parseFloat(rawDigits);
                // Enforce maximum value
                if (value && value > maxDuration) {
                    e.target.value = maxDuration;
                }
                // Enforce minimum value
                if (value && value < 1) {
                    e.target.value = 1;
                }
            });
            
            dom.durationInput.addEventListener('blur', function(e) {
                const raw = (e.target.value || '').trim();
                if (!raw) {
                    // Restore previous value if user didn't enter anything
                    e.target.value = previousDuration;
                    return;
                }
                let value = parseFloat(raw);
                if (!Number.isFinite(value)) {
                    // Invalid input: restore previous
                    e.target.value = previousDuration;
                    return;
                }
                // Enforce bounds
                if (value > maxDuration) {
                    value = maxDuration;
                }
                if (value < 1) {
                    value = 1;
                }
                e.target.value = String(Math.floor(value));
                previousDuration = e.target.value;
                saveStateToStorage();
            });
        }

        // Initialize amount input formatting
        if (dom.amountInput && dom.amountHidden) {
            const maxAmount = parseInt(dom.amountInput.dataset.max || '100000000', 10);
            
            // Block decimal point and comma input (only allow digits)
            dom.amountInput.addEventListener('keydown', function(e) {
                // Allow: backspace, delete, tab, escape, enter, and arrow keys
                if ([8, 9, 27, 13, 46, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
                    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    (e.keyCode === 65 && e.ctrlKey === true) ||
                    (e.keyCode === 67 && e.ctrlKey === true) ||
                    (e.keyCode === 86 && e.ctrlKey === true) ||
                    (e.keyCode === 88 && e.ctrlKey === true) ||
                    // Allow home, end
                    (e.keyCode >= 35 && e.keyCode <= 40)) {
                    return;
                }
                // Ensure that it is a number and stop the keypress if not
                if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                    e.preventDefault();
                }
            });
            
            // Format on input - handle locale-aware input (integers only)
            dom.amountInput.addEventListener('input', function(e) {
                const cursorPosition = e.target.selectionStart;
                const inputValue = e.target.value;
                
                // Get the numeric value (handles locale-aware parsing, integers only)
                const numericValueStr = getNumericValue(inputValue);
                let numericValue = numericValueStr ? parseInt(numericValueStr, 10) : null;
                
                // Enforce maximum value - allow exactly maxAmount, cap anything above
                if (numericValue !== null && Number.isFinite(numericValue)) {
                    if (numericValue > maxAmount) {
                        numericValue = maxAmount;
                    }
                    // numericValue is now <= maxAmount, including exactly maxAmount
                    
                    // Update hidden field with numeric value (no formatting)
                    dom.amountHidden.value = numericValue;
                    
                    // Format the display value with locale-aware formatting
                    const formatted = formatNumberWithCommas(numericValue);
                    e.target.value = formatted;
                    
                    // Try to maintain cursor position as best as possible
                    // This is approximate since locale formatting can change separators
                    const oldLength = inputValue.length;
                    const newLength = formatted.length;
                    const lengthDiff = newLength - oldLength;
                    
                    // Adjust cursor position (approximate)
                    let newCursorPosition = Math.max(0, Math.min(cursorPosition + lengthDiff, formatted.length));
                    e.target.setSelectionRange(newCursorPosition, newCursorPosition);
                } else if (!inputValue.trim()) {
                    // Empty input - clear hidden field
                    dom.amountHidden.value = '';
                    e.target.value = '';
                }
            });

            // Format on blur (when user leaves the field) - additional formatting
            // Note: Restoration logic is handled above in the focus/blur handlers section
            dom.amountInput.addEventListener('blur', function(e) {
                const numericValueStr = getNumericValue(e.target.value);
                if (numericValueStr) {
                    let numericValue = parseInt(numericValueStr, 10);
                    // Enforce maximum value - allow exactly maxAmount, cap anything above
                    if (numericValue !== null && Number.isFinite(numericValue)) {
                        if (numericValue > maxAmount) {
                            numericValue = maxAmount;
                        }
                        // numericValue is now <= maxAmount, including exactly maxAmount
                        e.target.value = formatNumberWithCommas(numericValue);
                        dom.amountHidden.value = numericValue;
                    }
                }
            });

            // Handle paste - parse locale-aware pasted text (integers only)
            dom.amountInput.addEventListener('paste', function(e) {
                e.preventDefault();
                const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                const numericValueStr = getNumericValue(pastedText);
                let numericValue = numericValueStr ? parseInt(numericValueStr, 10) : null;
                
                // Enforce maximum value - allow exactly maxAmount, cap anything above
                if (numericValue !== null && Number.isFinite(numericValue)) {
                    if (numericValue > maxAmount) {
                        numericValue = maxAmount;
                    }
                    // numericValue is now <= maxAmount, including exactly maxAmount
                    dom.amountHidden.value = numericValue;
                    e.target.value = formatNumberWithCommas(numericValue);
                } else {
                    // Invalid pasted value, clear
                    e.target.value = '';
                    dom.amountHidden.value = '';
                }
            });
        }

        function formatCurrency(amount) {
            if (!Number.isFinite(amount)) {
                return `${state.currency} 0.00`;
            }
            try {
                // Use HTML lang attribute set by Django (matches Django's language setting)
                const locale = document.documentElement.lang || navigator.language || 'en-US';
                return new Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: state.currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(amount);
            } catch (error) {
                return `${amount.toFixed(2)} ${state.currency}`;
            }
        }

        function showCalculatorError(message) {
            if (!dom.calculatorError) return;
            dom.calculatorError.textContent = message;
            dom.calculatorError.classList.remove('hidden');
        }

        function hideCalculatorError() {
            if (!dom.calculatorError) return;
            dom.calculatorError.classList.add('hidden');
        }

        function sortCardsByRate() {
            if (!dom.grid || cards.length === 0) return;
            const sortedCards = cards
                .slice()
                .sort((a, b) => (parseFloat(b.dataset.rate) || 0) - (parseFloat(a.dataset.rate) || 0));

            sortedCards.forEach(card => {
                const targetGrid = card.dataset.staleUpdate === 'true' && dom.staleGrid ? dom.staleGrid : dom.grid;
                targetGrid.appendChild(card);
            });
            syncStaleSectionVisibility();
        }

        function syncStaleSectionVisibility() {
            if (!dom.staleSection || !dom.staleGrid) return;
            const hasVisibleStaleCards = $$('.account-card', dom.staleGrid).some(card => !card.hasAttribute('hidden'));
            dom.staleSection.classList.toggle('hidden', !hasVisibleStaleCards);
        }

        function applyFilters() {
            if (cards.length === 0) return;
            cards.forEach(card => {
                const matchesCurrency = card.dataset.currency === state.currency;
                const matchesWelcome = state.filters.welcome || card.dataset.welcome !== 'true';
                const matchesYoung = state.filters.young || card.dataset.young !== 'true';
                const matchesPlus = state.filters.plus || card.dataset.plus !== 'true';
                const bankSlug = card.dataset.bankSlug;
                const bankFilterActive = state.selectedBanks.size > 0;
                const matchesBank = !bankFilterActive || !bankSlug || bankSlug === 'custom' || state.selectedBanks.has(bankSlug);
                const shouldShow = matchesCurrency && matchesWelcome && matchesYoung && matchesPlus && matchesBank;
                if (shouldShow) {
                    card.removeAttribute('hidden');
                    card.style.display = 'flex';
                } else {
                    card.setAttribute('hidden', '');
                    card.style.display = 'none';
                }
            });
            syncStaleSectionVisibility();
        }

        function updateFilterBadge() {
            if (!dom.activeFilterCount) return;
            const compoundAdjustment = state.filters.compound ? 0 : 1;
            const offerAdjustments = ['welcome', 'young', 'plus'].reduce(
                (total, key) => total + (state.filters[key] ? 0 : 1),
                0
            );
            // Do not count institution selection in Options badge; it has its own counter
            const bankAdjustment = 0;
            const assetAdjustments =
                assetSections.length === 0
                    ? 0
                    : Object.values(state.assetVisibility).reduce(
                          (total, visible) => total + (visible ? 0 : 1),
                          0
                      );
            const activeCount = compoundAdjustment + offerAdjustments + bankAdjustment + assetAdjustments;
            dom.activeFilterCount.textContent = activeCount;
            dom.activeFilterCount.classList.toggle('hidden', activeCount === 0);
        }

        function updateBankFilterCount() {
            if (!dom.bankFilterCount) return;
            const activeCount = state.selectedBanks.size;
            dom.bankFilterCount.textContent = activeCount;
            dom.bankFilterCount.classList.toggle('hidden', activeCount === 0);
        }

        function formatRelativeUpdate(date) {
            if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
                return '';
            }

            // Detect language from HTML lang attribute (tr or en)
            const htmlLang = document.documentElement.lang || 'en';
            const isTurkish = htmlLang.startsWith('tr');
            const updatedText = trans.updated || '';
            
            const diffSeconds = Math.round((Date.now() - date.getTime()) / 1000);
            const diffDays = Math.floor(diffSeconds / 86400);

            // Turkish format: "X min önce güncellendi"
            // English format: "updated X min ago"
            if (diffSeconds < 60) {
                return isTurkish ? `${trans.justNow} ${updatedText}` : `${updatedText} ${trans.justNow}`;
            }
            if (diffSeconds < 3600) {
                const minutes = Math.floor(diffSeconds / 60);
                const timeStr = `${minutes} ${trans.minAgo}`;
                return isTurkish ? `${timeStr} ${updatedText}` : `${updatedText} ${timeStr}`;
            }
            if (diffSeconds < 86400) {
                const hours = Math.floor(diffSeconds / 3600);
                const timeStr = hours === 1 ? `1 ${trans.hourAgo}` : `${hours} ${trans.hoursAgo}`;
                return isTurkish ? `${timeStr} ${updatedText}` : `${updatedText} ${timeStr}`;
            }
            if (diffDays === 1) {
                return isTurkish ? `${trans.yesterday} ${updatedText}` : `${updatedText} ${trans.yesterday}`;
            }
            if (diffDays < 7) {
                const timeStr = `${diffDays} ${trans.daysAgo}`;
                return isTurkish ? `${timeStr} ${updatedText}` : `${updatedText} ${timeStr}`;
            }
            if (diffDays < 30) {
                const weeks = Math.floor(diffDays / 7);
                const timeStr = weeks === 1 ? `1 ${trans.weekAgo}` : `${weeks} ${trans.weeksAgo}`;
                return isTurkish ? `${timeStr} ${updatedText}` : `${updatedText} ${timeStr}`;
            }
            if (diffDays < 365) {
                const months = Math.floor(diffDays / 30);
                const timeStr = months === 1 ? `1 ${trans.monthAgo}` : `${months} ${trans.monthsAgo}`;
                return isTurkish ? `${timeStr} ${updatedText}` : `${updatedText} ${timeStr}`;
            }
            const years = Math.floor(diffDays / 365);
            const timeStr = years === 1 ? `1 ${trans.yearAgo}` : `${years} ${trans.yearsAgo}`;
            return isTurkish ? `${timeStr} ${updatedText}` : `${updatedText} ${timeStr}`;
        }

        function isStaleUpdate(date) {
            if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
                return false;
            }
            return Date.now() - date.getTime() >= 7 * 86400 * 1000;
        }

        function formatRateSummary(card) {
            if (!card) return '';
            const parseRate = value => {
                if (typeof value === 'undefined') return NaN;
                return Number.parseFloat(String(value).replace(',', '.'));
            };

            const minRate = parseRate(card.dataset.minRate);
            const maxRate = parseRate(card.dataset.maxRate);

            if (!Number.isFinite(minRate) && !Number.isFinite(maxRate)) {
                return '';
            }

            const formatVal = value => {
                if (!Number.isFinite(value)) return '';
                // Format percentage with locale-aware decimal separator
                const locale = document.documentElement.lang || navigator.language || 'en-US';
                const formatted = value.toLocaleString(locale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
                return `${formatted}%`;
            };

            if (Number.isFinite(minRate) && Number.isFinite(maxRate)) {
                if (Math.abs(minRate - maxRate) < 0.0001) {
                    return `${formatVal(minRate)} ${trans.annualRateLabel}`;
                }
                return `${formatVal(minRate)} - ${formatVal(maxRate)} ${trans.annualRateLabel}`;
            }

            if (Number.isFinite(minRate)) {
                return `${formatVal(minRate)} ${trans.annualRateLabel}`;
            }

            return `${formatVal(maxRate)} ${trans.annualRateLabel}`;
        }

        function syncBankCheckboxes() {
            if (bankCheckboxes.length === 0) return;
            const shouldSelectAll = state.selectedBanks.size === 0;
            bankCheckboxes.forEach(checkbox => {
                checkbox.checked = shouldSelectAll || state.selectedBanks.has(checkbox.dataset.bankSlug);
            });
        }

        function filterBankList(query) {
            if (bankCheckboxes.length === 0) return;
            const normalized = (query || '').trim().toLowerCase();
            let visibleCount = 0;
            bankCheckboxes.forEach(checkbox => {
                const label = checkbox.closest('label');
                if (!label) return;
                const bankName = checkbox.dataset.bankName || '';
                const isVisible = !normalized || bankName.includes(normalized);
                label.classList.toggle('hidden', !isVisible);
                if (isVisible) visibleCount += 1;
            });
            if (dom.bankFilterEmpty) {
                dom.bankFilterEmpty.classList.toggle('hidden', visibleCount !== 0);
            }
        }

        function openBankFilterModal() {
            if (!modals.bankFilter) return;
            syncBankCheckboxes();
            if (dom.bankFilterSearch) dom.bankFilterSearch.value = '';
            filterBankList('');
            modals.bankFilter.show();
        }

        function closeBankFilterModal() {
            if (!modals.bankFilter) return;
            modals.bankFilter.hide();
            syncBankCheckboxes();
            if (dom.bankFilterSearch) dom.bankFilterSearch.value = '';
            filterBankList('');
        }

        function readBankSelectionFromCheckboxes() {
            const selection = new Set();
            bankCheckboxes.forEach(checkbox => {
                if (checkbox.checked) selection.add(checkbox.dataset.bankSlug);
            });
            return selection;
        }

        function applyBankSelectionFromModal() {
            if (bankCheckboxes.length === 0) {
                closeBankFilterModal();
                return;
            }
            const selection = readBankSelectionFromCheckboxes();
            if (selection.size === 0 || selection.size === totalBankCount) {
                state.selectedBanks = new Set();
            } else {
                state.selectedBanks = selection;
            }
            updateBankFilterCount();
            updateFilterBadge();
            applyFilters();
            sortCardsByRate();
            closeBankFilterModal();
        }

        function ensureCustomCard() {
            if (!dom.grid) return null;
            let card = document.getElementById('custom-rate-card');
            if (card) {
                card.dataset.currency = state.currency;
                return card;
            }
            card = document.createElement('div');
            card.id = 'custom-rate-card';
            card.className = 'account-card flex flex-col bg-white rounded-xl sm:rounded-2xl border border-gray-200 sm:border-2 hover:shadow-lg transition-all duration-300 overflow-hidden group hover:scale-105';
            card.style.borderColor = '#38bdf8';
            card.dataset.offerId = 'custom';
            card.dataset.bankSlug = 'custom';
            card.dataset.currency = state.currency;
            card.dataset.welcome = 'false';
            card.dataset.young = 'false';
            card.dataset.plus = 'false';
            card.dataset.rate = '0';
            card.innerHTML = `
                <div class="px-3 py-2" style="background: linear-gradient(135deg, rgba(56, 189, 248, 0.20) 0%, rgba(14, 165, 233, 0.10) 100%);">
                    <div class="flex items-center gap-3">
                        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center">
                            <img src="${CUSTOM_LOGO_URL}" alt="${trans.customRateTitle}" class="h-10 w-10 object-contain" loading="lazy" decoding="async">
                        </div>
                    </div>
                </div>
                <div class="card-content p-3 flex flex-col flex-grow gap-2">
                    <div class="space-y-1.5">
                        <h3 class="text-xs font-semibold text-gray-900 leading-tight line-clamp-2" data-role="custom-rate-title">${trans.customRateTitle}</h3>
                        <p class="text-[10px] text-gray-500 line-clamp-2" data-role="custom-rate-subtitle"></p>
                        <div class="calculation-result-btn rounded-lg px-2 py-1.5 cursor-pointer hover:opacity-90 transition-all duration-200" data-role="custom-rate-button" style="background-color: rgba(56, 189, 248, 0.12); color: #0369a1;">
                            <div class="text-center">
                                <div class="text-[10px] font-medium mb-0.5">${trans.netEarningLabel}</div>
                                <div class="text-sm sm:text-base font-bold mb-0.5 net-earning-val">-</div>
                                <div class="text-[10px] font-medium mb-0.5">${trans.netRateLabel}</div>
                                <div class="text-xs sm:text-sm font-semibold net-rate-val">-</div>
                            </div>
                        </div>
                    </div>
                <div class="mt-1.5 pt-1.5 border-t border-gray-100">
                    <div class="text-[10px] text-gray-400 leading-tight" data-role="custom-rates-header">${trans.customComparison}</div>
                    <div class="mt-1 space-y-1" data-role="custom-rates-list"></div>
                </div>
                </div>
            `;
            dom.grid.insertBefore(card, dom.grid.firstChild);
            refreshCards();
            return card;
        }

        // Create or get a custom result card for a given custom key (e.g., 'custom', 'custom_1')
        function ensureCustomResultCard(customKey) {
            if (!dom.grid || !customKey) return null;
            const cardId = `custom-rate-card-${customKey}`;
            let card = document.getElementById(cardId);
            if (card) {
                card.dataset.currency = state.currency;
                return card;
            }
            card = document.createElement('div');
            card.id = cardId;
            card.className = 'account-card flex flex-col bg-white rounded-xl sm:rounded-2xl border border-gray-200 sm:border-2 hover:shadow-lg transition-all duration-300 overflow-hidden group hover:scale-105';
            card.style.borderColor = '#38bdf8';
            card.dataset.offerId = customKey;
            card.dataset.bankSlug = 'custom';
            card.dataset.currency = state.currency;
            card.dataset.welcome = 'false';
            card.dataset.young = 'false';
            card.dataset.plus = 'false';
            card.dataset.rate = '0';
            card.innerHTML = `
                <div class="px-3 py-2" style="background: linear-gradient(135deg, rgba(56, 189, 248, 0.20) 0%, rgba(14, 165, 233, 0.10) 100%);">
                    <div class="flex items-center gap-3">
                        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center">
                            <img src="${CUSTOM_LOGO_URL}" alt="${trans.customRateTitle}" class="h-10 w-10 object-contain" loading="lazy" decoding="async">
                        </div>
                    </div>
                </div>
                <div class="card-content p-3 flex flex-col flex-grow gap-2">
                    <div class="space-y-1.5">
                        <h3 class="text-xs font-semibold text-gray-900 leading-tight line-clamp-2" data-role="custom-rate-title">${trans.customRateTitle}</h3>
                        <p class="text-[10px] text-gray-500 line-clamp-2" data-role="custom-rate-subtitle"></p>
                        <div class="calculation-result-btn rounded-lg px-2 py-1.5 cursor-pointer hover:opacity-90 transition-all duration-200" data-role="custom-rate-button" style="background-color: rgba(56, 189, 248, 0.12); color: #0369a1;">
                            <div class="text-center">
                                <div class="text-[10px] font-medium mb-0.5">${trans.netEarningLabel}</div>
                                <div class="text-sm sm:text-base font-bold mb-0.5 net-earning-val">-</div>
                                <div class="text-[10px] font-medium mb-0.5">${trans.netRateLabel}</div>
                                <div class="text-xs sm:text-sm font-semibold net-rate-val">-</div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-1.5 pt-1.5 border-t border-gray-100">
                        <div class="text-[10px] text-gray-400 leading-tight">${trans.customComparison}</div>
                    </div>
                </div>
            `;
            dom.grid.insertBefore(card, dom.grid.firstChild);
            refreshCards();
            return card;
        }

        function removeAllCustomResultCards() {
            if (!dom.grid) return;
            const cardsToRemove = Array.from(dom.grid.querySelectorAll('[id^="custom-rate-card-custom"]'));
            cardsToRemove.forEach(c => c.parentNode && c.parentNode.removeChild(c));
            refreshCards();
        }

        function removeCustomCard() {
            const existing = document.getElementById('custom-rate-card');
            if (existing && existing.parentNode) {
                existing.parentNode.removeChild(existing);
                refreshCards();
                state.detailEndpoints.delete('custom');
                applyFilters();
            }
        }

        function updateCustomRateIndicator() {
            if (!dom.customRateIndicator) return;
            const count = state.customRate ? 1 : (Array.isArray(state.customRates) ? state.customRates.length : 0);
            if (count > 0) {
                dom.customRateIndicator.textContent = String(count);
                dom.customRateIndicator.classList.remove('hidden');
            } else {
                dom.customRateIndicator.textContent = '';
                dom.customRateIndicator.classList.add('hidden');
            }
        }

        function buildCustomRateRow(data = {}) {
            const id = Math.random().toString(36).slice(2);
            const row = document.createElement('div');
            row.className = 'custom-rate-item space-y-3';
            row.dataset.rowId = id;
            const currencyInfo = currencyMap[state.currency] || { code: state.currency, symbol: state.currency };
            const symbol = currencyInfo.symbol || currencyInfo.code || '';
            row.innerHTML = `
                <div>
			<label class="block text-xs font-semibold text-gray-700 mb-1">${trans.nameLabel}</label>
                    <input type="text" class="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm" value="${data.name || ''}" placeholder="${trans.customRateTitle || 'Custom Rate'}">
                </div>
                <div>
                    <label class="block text-xs font-semibold text-gray-700 mb-1">${trans.annualRateLabel}</label>
                    <div class="relative">
                        <input type="number" step="0.01" min="0" class="w-full pr-10 pl-3 py-2 border border-gray-200 rounded-lg text-sm" value="${typeof data.rate !== 'undefined' ? data.rate : ''}" placeholder="5.25">
                        <span class="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-gray-500">%</span>
                    </div>
                </div>
                <div>
                    <label class="block text-xs font-semibold text-gray-700 mb-1">${trans.passiveBalanceLabel}</label>
                    <div class="relative">
                        <input type="number" step="0.01" min="0" class="w-full pr-8 pl-3 py-2 border border-gray-200 rounded-lg text-sm" value="${typeof data.passiveBalance !== 'undefined' ? data.passiveBalance : ''}" placeholder="5000">
                        <span class="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-gray-500">${symbol}</span>
                    </div>
                </div>
                <div>
				<label class="block text-xs font-semibold text-gray-700 mb-1">${trans.passiveBalanceLabel} — ${trans.annualRateLabel}</label>
                    <div class="relative">
                        <input type="number" step="0.01" min="0" class="w-full pr-10 pl-3 py-2 border border-gray-200 rounded-lg text-sm" value="${typeof data.passiveRate !== 'undefined' ? data.passiveRate : ''}" placeholder="5.25">
                        <span class="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-gray-500">%</span>
                    </div>
                </div>
                <div class="flex items-center gap-2 min-w-0">
                    <input type="checkbox" class="h-4 w-4 rounded border-gray-300 text-brand-primary focus:ring-brand-accent flex-shrink-0" ${data.weekend ? 'checked' : ''} style="accent-color: currentColor;">
                    <label class="text-xs text-gray-700 leading-tight">${trans.paybacksWeekend}</label>
                </div>
                <div class="flex justify-end">
                    <button type="button" class="remove-rate-row text-xs font-semibold px-3 py-2 rounded-lg border text-rose-700 border-rose-200 hover:bg-rose-50">${trans.remove || 'Remove'}</button>
                </div>
            `;
            // Update the corresponding tab title when name changes
            const nameInput = row.querySelector('input[type="text"]');
            if (nameInput) {
                nameInput.addEventListener('input', () => {
                    if (!dom.customRateTabs) return;
                    const tabBtn = dom.customRateTabs.querySelector(`[data-row-id="${row.dataset.rowId}"]`);
                    if (tabBtn) {
                        const base = (trans.customRateTitle || 'Custom Rate');
                        const label = String(nameInput.value || '').trim() || base;
                        tabBtn.textContent = label;
                    }
                });
            }
            const removeBtn = row.querySelector('.remove-rate-row');
            removeBtn.addEventListener('click', () => {
                const list = dom.customRateList;
                if (!list) return;
                const rows = Array.from(list.children);
                const removedIndex = rows.indexOf(row);
                list.removeChild(row);
                // prevent removing all rows; keep at least one
                if (list.children.length === 0) addCustomRateRow();
                updateAddButtonState();
                const newIndex = Math.max(0, Math.min(removedIndex, list.children.length - 1));
                rebuildCustomRateTabs(newIndex);
            });
            return row;
        }

        function addCustomRateRow(prefill = {}) {
            if (!dom.customRateList) return;
            if (dom.customRateList.children.length >= 4) return;
            const row = buildCustomRateRow(prefill);
            dom.customRateList.appendChild(row);
            updateAddButtonState();
            rebuildCustomRateTabs(dom.customRateList.children.length - 1);
        }

        function clearCustomRateInputs() {
            if (dom.customRateList) dom.customRateList.innerHTML = '';
            updateAddButtonState();
        }

        function updateAddButtonState() {
            if (!dom.customRateAdd || !dom.customRateList) return;
            const count = dom.customRateList.children.length;
            const disabled = count >= 4;
            dom.customRateAdd.disabled = disabled;
            dom.customRateAdd.classList.toggle('opacity-50', disabled);
            dom.customRateAdd.classList.toggle('cursor-not-allowed', disabled);
        }

        function setActiveCustomRateIndex(index) {
            if (!dom.customRateList || !dom.customRateTabs) return;
            const rows = Array.from(dom.customRateList.children);
            rows.forEach((row, i) => {
                row.classList.toggle('hidden', i !== index);
            });
            const tabs = Array.from(dom.customRateTabs.children);
            tabs.forEach((tab, i) => {
                if (i === index) {
                    tab.classList.add('border', 'border-brand-accent', 'shadow-sm');
                    tab.style.backgroundColor = '#c1ff7215';
                    tab.style.color = '#2e1818';
                    tab.style.opacity = '1';
                } else {
                    tab.classList.remove('border', 'border-brand-accent');
                    tab.style.backgroundColor = '';
                    tab.style.color = '';
                    tab.style.opacity = '0.85';
                }
            });
        }

        function rebuildCustomRateTabs(activeIndex = 0) {
            if (!dom.customRateTabs || !dom.customRateList) return;
            const count = dom.customRateList.children.length;
            dom.customRateTabs.innerHTML = '';
            for (let i = 0; i < count; i++) {
                const row = dom.customRateList.children[i];
                const nameInput = row ? row.querySelector('input[type="text"]') : null;
                const customName = nameInput ? String(nameInput.value || '').trim() : '';
                const label = customName || `${(trans.customRateTitle || 'Custom Rate')} ${i + 1}`;
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'text-[11px] font-semibold px-3 py-1 rounded-full border transition-colors border-brand-accent bg-white hover:bg-[#c1ff7215] hover:opacity-100 opacity-85';
                btn.setAttribute('data-row-id', row ? row.dataset.rowId || '' : '');
                btn.style.color = '#2e1818';
                btn.textContent = label;
                btn.addEventListener('click', () => setActiveCustomRateIndex(i));
                dom.customRateTabs.appendChild(btn);
            }
            setActiveCustomRateIndex(Math.max(0, Math.min(activeIndex, count - 1)));
        }

        function updateCurrencySymbol() {
            if (dom.calculatorCurrencySymbol) {
                const currencyInfo = currencyMap[state.currency];
                const displaySymbol = currencyInfo && currencyInfo.symbol ? currencyInfo.symbol : (currencyInfo ? currencyInfo.code : state.currency);
                dom.calculatorCurrencySymbol.textContent = displaySymbol;
            }
        }

        function syncCurrencyButtons() {
            currencyButtons.forEach(button => {
                const isActive = button.dataset.currency === state.currency;
                button.classList.toggle('bg-brand-primary', isActive);
                button.classList.toggle('text-white', isActive);
                button.classList.toggle('border-brand-primary', isActive);
                button.classList.toggle('hover:bg-opacity-90', isActive);
                button.classList.toggle('bg-white', !isActive);
                button.classList.toggle('text-gray-600', !isActive);
                button.classList.toggle('border-gray-200', !isActive);
                button.classList.toggle('hover:bg-gray-50', !isActive);
            });
        }

        function syncFilterCheckboxes() {
            if (filterCheckboxes.compound) filterCheckboxes.compound.checked = state.filters.compound;
            if (filterCheckboxes.welcome) filterCheckboxes.welcome.checked = state.filters.welcome;
            if (filterCheckboxes.young) filterCheckboxes.young.checked = state.filters.young;
            if (filterCheckboxes.plus) filterCheckboxes.plus.checked = state.filters.plus;
            if (dom.rateDisplaySelect) dom.rateDisplaySelect.value = state.filters.rateDisplay || 'net';
        }

        function syncAssetCheckboxes() {
            if (assetCheckboxes.currencies) assetCheckboxes.currencies.checked = state.assetVisibility.currencies;
            if (assetCheckboxes.commodities) assetCheckboxes.commodities.checked = state.assetVisibility.commodities;
            if (assetCheckboxes.cryptocurrencies) assetCheckboxes.cryptocurrencies.checked = state.assetVisibility.cryptocurrencies;
        }

        let marketPerformanceData = null;
        let marketPerformanceDefaultBase = 'TRY';

        function getCurrencyDisplayName(code) {
            const normalizedCode = (code || state.currency || 'TRY').toUpperCase();
            const currencyInfo = currencyMap[normalizedCode];
            return (currencyInfo && currencyInfo.name) || normalizedCode;
        }

        function updateMarketPerformanceTitle(baseCode = state.currency) {
            const heading = document.getElementById('asset-performance-heading');
            if (!heading) return;
            const currencyName = getCurrencyDisplayName(baseCode);
            const isTurkish = (document.documentElement.lang || '').toLowerCase().startsWith('tr');
            heading.textContent = isTurkish
                ? `${currencyName} için Piyasa Performansı`
                : `Market Performance for ${currencyName}`;
        }

        async function fetchMarketPerformance(currencyCode) {
            if (!dom.assetPerformanceBlock) return null;
            const apiUrl = dom.assetPerformanceBlock.dataset.apiUrl;
            if (!apiUrl) return null;

            try {
                const url = `${apiUrl}?currency=${encodeURIComponent(currencyCode || 'TRY')}`;
                const response = await fetch(url, noStoreFetchOptions);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const json = await response.json();
                if (json.success && json.data) {
                    return json.data;
                }
                return null;
            } catch (error) {
                return null;
            }
        }

        function formatNumberWithDecimals(value, decimals = 2) {
            if (value === null || value === undefined) return '—';
            const num = parseFloat(value);
            if (!Number.isFinite(num)) return '—';
            const locale = document.documentElement.lang || navigator.language || 'en-US';
            const rounded = Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
            const isInteger = Math.abs(rounded - Math.round(rounded)) < 0.0001;
            if (isInteger) {
                return num.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            }
            return num.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        }

        function formatAssetValue(value) {
            if (value === null || value === undefined) return '—';
            const num = parseFloat(value);
            if (!Number.isFinite(num)) return '—';
            const locale = document.documentElement.lang || navigator.language || 'en-US';
            const decimals = Math.abs(num) >= 1000 ? 0 : 2;
            return num.toLocaleString(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        }

        function formatDate(dateString) {
            if (!dateString) return '—';
            try {
                const date = new Date(dateString);
                if (Number.isNaN(date.getTime())) return dateString;
                const hasTime = /T\d{2}:\d{2}/.test(dateString);
                const opts = hasTime
                    ? { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
                    : { year: 'numeric', month: '2-digit', day: '2-digit' };
                const formatted = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', opts).format(date);
                return hasTime ? formatted : formatted.replace(/\//g, '-');
            } catch (e) {
                return dateString;
            }
        }

        function formatAssetUpdateLabel(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const relativeLabel = formatRelativeUpdate(date);
            return relativeLabel || formatDate(dateString);
        }

        function renderMarketPerformance(data) {
            if (!data || !data.sections || !Array.isArray(data.sections)) {
                const contentEl = document.getElementById('asset-performance-content');
                if (contentEl) {
                    contentEl.innerHTML = '<p class="text-sm text-gray-500 text-center py-8">' + 
                        (trans.noPerformanceData || trans.noDailyPostings || 'No performance data available.') + '</p>';
                }
                if (dom.assetPerformanceBlock) {
                    dom.assetPerformanceBlock.classList.add('hidden');
                }
                return;
            }

            marketPerformanceDefaultBase = data.base || 'TRY';
            marketPerformanceData = data;
            updateMarketPerformanceTitle(marketPerformanceDefaultBase);

            const contentEl = document.getElementById('asset-performance-content');
            if (!contentEl) return;

            const sections = data.sections || [];
            if (sections.length === 0) {
                contentEl.innerHTML = '';
                if (dom.assetPerformanceBlock) {
                    dom.assetPerformanceBlock.classList.add('hidden');
                }
                return;
            }

            const baseCode = data.base || '';
            const baseSymbol = data.base_symbol || baseCode;

            let html = '<div class="asset-performance-wrapper" data-base="' + baseCode + '">';
            html += '<div class="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4 xl:gap-5">';

            sections.forEach(section => {
                const kind = (section.kind || '').toLowerCase();
                const entries = section.entries || [];
                
                if (entries.length === 0) return;
                
                entries.forEach(entry => {
                    const assetCode = entry.asset_code || '';
                    const assetName = entry.asset_name || '';
                    const latestValue = entry.latest_value || '';
                    const latestDate = entry.latest_date || '';
                    const latestDateTitle = formatDate(latestDate);
                    const updateLabel = formatAssetUpdateLabel(latestDate);
                    const periods = entry.periods || [];

                    html += '<div class="flex flex-col gap-4 rounded-xl sm:rounded-2xl border sm:border-2 bg-white p-3 shadow-sm hover:shadow-lg transition-all duration-300 asset-performance-section" style="border-color: #2e1818;" data-asset-kind="' + kind + '">';
                    html += '<div class="flex flex-wrap items-start justify-between gap-3">';
                    html += '<div>';
                    html += '<div class="flex items-center gap-2">';
                    html += '<span class="text-lg font-semibold text-gray-900">' + assetCode + '</span>';
                    html += '</div>';
                    html += '<div class="text-[11px] text-gray-500 capitalize tracking-wide truncate">' + assetName + '</div>';
                    html += '</div>';
                    html += '<div class="text-right leading-tight">';
                    html += '<div class="text-lg font-semibold text-gray-900">' + 
                        formatAssetValue(latestValue) + baseSymbol + '</div>';
                    if (updateLabel) {
                        html += '<div class="text-[10px] text-gray-400" title="' + latestDateTitle + '">' + updateLabel + '</div>';
                    }
                    html += '</div>';
                    html += '</div>';
                    html += '<div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">';

                    periods.forEach(period => {
                        const periodDays = period.period || 0;
                        const change = period.change !== null ? parseFloat(period.change) : null;
                        const annualized = period.annualized !== null ? parseFloat(period.annualized) : null;

                        html += '<div class="rounded-xl border bg-white px-3.5 py-2.5 text-center text-[13px] shadow-sm" style="border-color: #2e1818;">';
                        html += '<div class="font-semibold uppercase tracking-wide text-gray-600 text-[11px]">' + periodDays + 'D</div>';
                        if (change !== null) {
                            const changeClass = change < 0 ? 'text-rose-600' : (change > 0 ? 'text-emerald-600' : 'text-gray-600');
                            const changeSign = change > 0 ? '+' : '';
                            html += '<div class="' + changeClass + ' text-base font-semibold">' + changeSign + formatNumberWithDecimals(change, 2) + '%</div>';
                            if (annualized !== null) {
                                const annSign = annualized > 0 ? '+' : '';
                                html += '<div class="text-[11px] text-gray-500 leading-tight">' + trans.annualApprox + ' ' + annSign + formatNumberWithDecimals(annualized, 2) + '%</div>';
                            }
                        } else {
                            html += '<div class="text-gray-400">—</div>';
                        }
                        html += '</div>';
                    });

                    html += '</div>';
                    html += '</div>';
                });

                if (section.has_more_entries && section.total_entries) {
                    html += '<div class="col-span-full text-[11px] text-gray-500 bg-gray-50 border border-dashed border-gray-200 rounded-xl px-3.5 py-2.5 text-center">';
                    html += replaceCountPlaceholder(trans.showingTopEntries, section.total_entries);
                    html += '</div>';
                }
            });

            html += '</div>';
            html += '<p class="asset-performance-empty-selection hidden text-xs text-gray-500 bg-gray-50 border border-dashed border-gray-200 rounded-xl px-4 py-3 text-center">';
            html += trans.allCategoriesHidden;
            html += '</p>';
            html += '</div>';

            contentEl.innerHTML = html;

            // Refresh asset sections references
            assetSections.length = 0;
            assetSections.push(...$$('.asset-performance-section'));
            assetWrappers.length = 0;
            assetWrappers.push(...$$('.asset-performance-wrapper'));

            updateAssetSections();
            
            if (dom.assetPerformanceBlock) {
                dom.assetPerformanceBlock.classList.remove('hidden');
            }
        }

        async function loadMarketPerformance() {
            if (!dom.assetPerformanceBlock) return;
            const contentEl = document.getElementById('asset-performance-content');
            if (contentEl) {
                contentEl.innerHTML = `<div class="text-center py-8"><p class="text-sm text-gray-500">${trans.loadingMarketPerformance}</p></div>`;
            }
            const data = await fetchMarketPerformance(state.currency);
            renderMarketPerformance(data);
        }

        function updateAssetWrapperVisibility() {
            // This function is now handled by loadMarketPerformance which renders the correct base
            if (marketPerformanceData) {
                renderMarketPerformance(marketPerformanceData);
            }
        }

        function updateAssetSections() {
            if (assetSections.length === 0) return;
            assetSections.forEach(section => {
                const kind = (section.dataset.assetKind || '').toLowerCase();
                let visible = true;
                if (kind === 'currency') {
                    visible = state.assetVisibility.currencies;
                } else if (kind === 'commodity') {
                    visible = state.assetVisibility.commodities;
                } else if (kind === 'cryptocurrency') {
                    visible = state.assetVisibility.cryptocurrencies;
                }
                section.classList.toggle('hidden', !visible);
            });
            assetWrappers.forEach(wrapper => {
                const sections = $$('.asset-performance-section', wrapper);
                const hasVisibleSection = sections.some(section => !section.classList.contains('hidden'));
                const emptyNote = $('.asset-performance-empty-selection', wrapper);
                if (emptyNote) {
                    emptyNote.classList.toggle('hidden', hasVisibleSection);
                }
            });
        }

        async function applySettings() {
            if (filterCheckboxes.compound) state.filters.compound = filterCheckboxes.compound.checked;
            if (filterCheckboxes.welcome) state.filters.welcome = filterCheckboxes.welcome.checked;
            if (filterCheckboxes.young) state.filters.young = filterCheckboxes.young.checked;
            if (filterCheckboxes.plus) state.filters.plus = filterCheckboxes.plus.checked;
            if (dom.rateDisplaySelect) state.filters.rateDisplay = dom.rateDisplaySelect.value;
            saveStateToStorage();
            Object.entries(assetCheckboxes).forEach(([key, checkbox]) => {
                if (checkbox) {
                    state.assetVisibility[key] = checkbox.checked;
                }
            });
            updateFilterBadge();
            if (modals.settings) modals.settings.hide();
            await loadOffers();
            updateAssetSections();
        }

        function clearSettings() {
            state.filters = { ...defaultFilters };
            state.assetVisibility = { ...defaultAssetVisibility };
            syncFilterCheckboxes();
            syncAssetCheckboxes();
            applySettings();
        }

        function updateTaxWarning() {
            const taxWarningBox = document.getElementById('tax-warning-box');
            const taxWarningText = document.getElementById('tax-warning-text');
            if (!taxWarningBox || !taxWarningText) return;
            
            // Check if user has closed the warning for this specific currency
            const currencyCode = state.currency || 'TRY';
            const warningClosedKey = `tax-warning-closed-${currencyCode}`;
            const warningClosed = localStorage.getItem(warningClosedKey);
            if (warningClosed === 'true') {
                taxWarningBox.style.display = 'none';
                return;
            }
            
            const taxRate = currencyCode === 'TRY' ? '17.5%' : '25%';
            const baseMessage = (trans.allRatesNet || 'All rates shown are net rates (after') + ' ' + taxRate + ' ' + (trans.withholdingTax || 'withholding tax)');
            taxWarningText.textContent = baseMessage;
            taxWarningBox.style.display = '';
        }

        function setCurrency(code) {
            state.currency = code;
            updateCurrencySymbol();
            syncCurrencyButtons();
            updateTaxWarning();
            loadOffers();
            loadMarketPerformance();
        }

        function updateCardResult(card, result) {
            const button = $('.calculation-result-btn', card);
            const metaWrapper = $('.calculation-meta', card);
            const rateSummaryEl = $('.calculation-rate-text', card);
            const defaultUpdate = $('.default-update', card);
            const annualRateBlock = $('.annual-rate-block', card);
            const contentWrapper = $('.card-content', card);
            if (!button) return;

            const offerId = card.dataset.offerId;
            const detailKey = String(offerId);

            const resetCard = () => {
                card.dataset.rate = 0;
                button.classList.add('hidden');
                delete button.dataset.details;
                delete button.dataset.detailOfferId;
                delete button.dataset.detailUrl;
                delete button.dataset.detailPageUrl;
                delete button.dataset.detailAvailable;
                state.detailEndpoints.delete(detailKey);
                // Reset rate displays depending on format
                const grossRateDisplay = $('.gross-rate-display', card);
                const netRateDisplay = $('.net-rate-display', card);
                const isGrossPrimary = state.filters.rateDisplay === 'gross';
                if (grossRateDisplay) grossRateDisplay.classList.toggle('hidden', isGrossPrimary);
                if (netRateDisplay) netRateDisplay.classList.toggle('hidden', !isGrossPrimary);
                if (annualRateBlock) annualRateBlock.classList.remove('hidden');
                if (contentWrapper) {
                    contentWrapper.classList.remove('justify-between');
                    contentWrapper.classList.add('items-center');
                }
                // Restore default vertical spacing above calculation block and title stack
                const annualBlock = contentWrapper ? contentWrapper.querySelector('.annual-rate-block') : null;
                const headerStack = annualBlock ? annualBlock.parentElement : null;
                if (headerStack) {
                    headerStack.classList.remove('space-y-0.5', 'space-y-1');
                    headerStack.classList.add('space-y-1.5');
                }
                const calcBlock = $('.calculation-block', card);
                if (calcBlock) {
                    calcBlock.classList.remove('mt-0.5', 'mt-0');
                    calcBlock.classList.add('mt-1.5');
                }
                card.classList.remove('has-calculation');
            };

            if (!result || result.error) {
                resetCard();
                return;
            }

            let summary = result.summary;
            if (!summary && typeof result.total_earning_net !== 'undefined') {
                summary = {
                    total_earning_net: result.total_earning_net,
                    real_annual_rate: result.real_annual_rate,
                    real_annual_rate_numeric: result.real_annual_rate_numeric,
                };
            }
            if (!summary) {
                resetCard();
                return;
            }

            const earningEl = $('.net-earning-val', button);
            const rateEl = $('.net-rate-val', button);

            const rateNumeric = Number(summary.real_annual_rate_numeric);
            card.dataset.rate = Number.isFinite(rateNumeric) ? rateNumeric : 0;

            if (earningEl) earningEl.textContent = summary.total_earning_net ?? '—';
            if (rateEl) {
                const locale = document.documentElement.lang || navigator.language || 'en-US';
                const rateNum = Number(summary.real_annual_rate_numeric);
                if (Number.isFinite(rateNum)) {
                    const localized = new Intl.NumberFormat(locale, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }).format(rateNum);
                    rateEl.textContent = `${localized}%`;
                } else {
                    rateEl.textContent = summary.real_annual_rate ?? '—';
                }
            }

            if (offerId && offerId.startsWith('custom')) {
                const titleEl = card.querySelector('[data-role="custom-rate-title"]');
                const subtitleEl = card.querySelector('[data-role="custom-rate-subtitle"]');
                const locale = document.documentElement.lang || 'en-US';
                card.dataset.currency = state.currency;
                if (titleEl) {
                    let customName = '';
                    if (offerId === 'custom') {
                        customName = (state.customRate && String(state.customRate.name || '').trim()) || '';
                    } else if (offerId.startsWith('custom_')) {
                        const idxStr = offerId.split('_')[1];
                        const idx = parseInt(idxStr, 10);
                        if (Number.isFinite(idx) && Array.isArray(state.customRates) && state.customRates[idx - 1]) {
                            customName = String(state.customRates[idx - 1].name || '').trim();
                        }
                    }
                    const displayName = (result.summary && result.summary.account_name) || result.account_name || customName || trans.customRateTitle;
                    titleEl.textContent = displayName;
                }
                if (subtitleEl) {
                    subtitleEl.textContent = '';
                }
            }

            const detailUrl = result.detail_api_url || result.detailUrl || result.detail_url || null;
            const detailPageUrl = normalizeDailyDepositDetailUrl(result.detail_page_url || result.detailPageUrl || null);

            delete button.dataset.details;
            button.dataset.detailOfferId = offerId;
            if (detailUrl) {
                button.dataset.detailUrl = detailUrl;
                button.dataset.detailAvailable = 'true';
                state.detailEndpoints.set(detailKey, detailUrl);
            } else {
                delete button.dataset.detailUrl;
                delete button.dataset.detailAvailable;
                state.detailEndpoints.delete(detailKey);
                // If inline detail exists (e.g., custom), attach it for modal rendering
                if (result.detail) {
                    try {
                        button.dataset.details = JSON.stringify(result.detail);
                    } catch (_) {
                        // ignore serialization errors
                    }
                }
            }
            if (detailPageUrl) {
                button.dataset.detailPageUrl = detailPageUrl;
            } else {
                delete button.dataset.detailPageUrl;
            }
			const hasInlineDetails = !!button.dataset.details;
			button.classList.toggle('cursor-not-allowed', !detailUrl && !detailPageUrl && !hasInlineDetails);
			if (!detailUrl && !detailPageUrl && !hasInlineDetails) {
                button.title = trans.viewDetailsDisabled;
            } else {
                button.removeAttribute('title');
            }

            button.classList.remove('hidden');
            // Toggle rate displays based on format after calculation
            const grossRateDisplay = $('.gross-rate-display', card);
            const netRateDisplay = $('.net-rate-display', card);
            const isGrossPrimary = state.filters.rateDisplay === 'gross';
            if (grossRateDisplay) grossRateDisplay.classList.toggle('hidden', !isGrossPrimary);
            if (netRateDisplay) netRateDisplay.classList.toggle('hidden', isGrossPrimary);
            if (annualRateBlock) annualRateBlock.classList.add('hidden');
            if (contentWrapper) {
                contentWrapper.classList.remove('items-center');
                contentWrapper.classList.add('justify-between');
            }
            // Tighten spacing between account name and calculation box when visible
            const calcBlock = $('.calculation-block', card);
            if (calcBlock) {
                calcBlock.classList.remove('mt-1.5');
                calcBlock.classList.add('mt-0');
            }
            // Reduce vertical gap in the title/annual-rate stack
            const annualBlock2 = contentWrapper ? contentWrapper.querySelector('.annual-rate-block') : null;
            const headerStack2 = annualBlock2 ? annualBlock2.parentElement : null;
            if (headerStack2) {
                headerStack2.classList.remove('space-y-1.5');
                headerStack2.classList.add('space-y-0.5');
            }
            card.classList.add('has-calculation');
            updateRelativeTimes();
        }

        async function performCalculation() {
            if (!dom.calculatorForm) return;

            // Get numeric value from hidden input (without commas)
            const amount = getAmountValue();
            const duration = dom.durationInput ? parseInt(dom.durationInput.value, 10) : NaN;
            const startDate = getSelectedStartDate();

            hideCalculatorError();
            if (modals.disclaimer) modals.disclaimer.hide();

            const submitBtn = dom.disclaimerButton;
            const originalButtonHtml = submitBtn ? submitBtn.innerHTML : '';

            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.innerHTML = `<svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>${trans.calculating}`;
            }

            try {
                if (!Number.isFinite(amount) || amount <= 0) {
                    throw new Error(trans.pleaseEnterValidAmount || trans.unknownError);
                }
                if (!Number.isFinite(duration) || duration <= 0 || duration > 700) {
                    throw new Error(trans.durationInvalid || trans.unknownError);
                }

                const apiUrl = dom.calculatorForm.dataset.apiUrl;

                if (!apiUrl) {
                    throw new Error(trans.unknownError);
                }

                const payload = {
                    amount,
                    duration,
                    start_date: startDate,
                    currency: state.currency,
                    days_cumulative: state.filters.compound,
                    include_welcome_offers: state.filters.welcome,
                    include_young_offers: state.filters.young,
                    include_plus_offers: state.filters.plus,
                    selected_banks: Array.from(state.selectedBanks),
                };

            if (state.customRate) {
                    const annualRate = Number(state.customRate.rate);
                    const passiveBalance = Number(state.customRate.passiveBalance) || 0;
                    const passiveAnnualRate = Number(state.customRate.passiveRate) || 0;
                    const weekend = !!state.customRate.weekend;
                    const customRatePayload = {
                        name: state.customRate.name || undefined,
                        annual_rate: Number.isFinite(annualRate) ? annualRate : undefined,
                    };
                    if (passiveBalance > 0) {
                        customRatePayload.passive_balance = passiveBalance;
                        if (passiveAnnualRate > 0) {
                            customRatePayload.passive_annual_rate = passiveAnnualRate;
                        }
                    }
                    if (weekend) {
                        customRatePayload.weekend = weekend;
                    }
                payload.custom_rate = customRatePayload;
            } else if (state.customRates && state.customRates.length) {
                payload.custom_rates = state.customRates.slice(0, 4).map(cr => {
                    const annualRate = Number(cr.rate);
                    const passiveBalance = Number(cr.passiveBalance) || 0;
                    const passiveAnnualRate = Number(cr.passiveRate) || 0;
                    const weekend = !!cr.weekend;
                    const obj = { name: cr.name || undefined, annual_rate: annualRate };
                    if (passiveBalance > 0) {
                        obj.passive_balance = passiveBalance;
                        if (passiveAnnualRate > 0) obj.passive_annual_rate = passiveAnnualRate;
                    }
                    if (weekend) obj.weekend = weekend;
                    return obj;
                });
                }

                state.lastCalculationPayload = {
                    amount,
                    duration,
                    start_date: payload.start_date,
                    currency: payload.currency,
                    days_cumulative: payload.days_cumulative,
                    include_welcome_offers: payload.include_welcome_offers,
                    include_young_offers: payload.include_young_offers,
                    include_plus_offers: payload.include_plus_offers,
                    selected_banks: [...payload.selected_banks],
                    custom_rate: payload.custom_rate ? { ...payload.custom_rate } : null,
                    custom_rates: payload.custom_rates ? payload.custom_rates.map(x => ({ ...x })) : null,
                };

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: buildJsonHeaders(),
                    body: JSON.stringify(payload),
                });

                // Check if response is JSON before parsing
                const contentType = response.headers.get('content-type');
                let data;
                
                try {
                    if (contentType && contentType.includes('application/json')) {
                        data = await response.json();
                    } else {
                        // If not JSON, get text to see what we got
                        const text = await response.text();
                        throw new Error(`${trans.unknownError} (Server returned non-JSON: ${response.status} ${response.statusText})`);
                    }
                } catch (parseError) {
                    // If JSON parsing fails (even if content-type says JSON), handle gracefully
                    if (parseError instanceof SyntaxError || (parseError.message && parseError.message.includes('JSON'))) {
                        // Try to get the text for debugging
                        try {
                            const text = await response.clone().text();
                        } catch (e) {
                            // Response already read, can't clone
                        }
                        throw new Error(`${trans.unknownError} (Invalid response format from server)`);
                    }
                    throw parseError;
                }

                if (!response.ok) {
                    throw new Error(getApiErrorMessage(data, trans.unknownError));
                }

                if (data && data.success === false) {
                    throw new Error(getApiErrorMessage(data, trans.unknownError));
                }

                const results = data.results || {};
                refreshCards();
                state.detailEndpoints = new Map();
                detailCache.clear();

                // Render each custom result as its own card
                removeAllCustomResultCards();
                const customKeys = Object.keys(results).filter(k => String(k).startsWith('custom'));
                if (customKeys.length) hideCalculatorError();
                customKeys.forEach(key => {
                    const res = results[key];
                    if (!res || res.error) return;
                    const card = ensureCustomResultCard(key);
                    if (card) updateCardResult(card, res);
                });

                refreshCards();
                cards.forEach(card => {
                    updateCardResult(card, results[card.dataset.offerId]);
                });

                sortCardsByRate();
                applyFilters();

                if (dom.clearCalculationButton) dom.clearCalculationButton.classList.remove('hidden');
            } catch (error) {
                showCalculatorError(`${trans.error}: ${error.message}`);
            } finally {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalButtonHtml || trans.calculating;
                }
            }
        }

        function clearCalculation() {
            if (dom.clearCalculationButton) dom.clearCalculationButton.classList.add('hidden');
            state.lastCalculationPayload = null;
            state.detailEndpoints = new Map();
            detailCache.clear();
            removeAllCustomResultCards();
            refreshCards();
            cards.forEach(card => {
                updateCardResult(card, null);
            });
            sortCardsByRate();
            applyFilters();
        }


        function showDetails(details) {
            if (!modals.details || !dom.modalTitle || !dom.modalBody) return;

            const detectCurrency = formatted => {
                if (!formatted) return { symbol: '', position: 'prefix' };
                const trimmed = String(formatted).trim();
                const prefix = trimmed.match(/^[^\d\-.,]+/);
                const suffix = trimmed.match(/[^\d\-.,]+$/);
                if (prefix) return { symbol: prefix[0], position: 'prefix' };
                if (suffix) return { symbol: suffix[0], position: 'suffix' };
                return { symbol: '', position: 'prefix' };
            };

            const currencyInfo = detectCurrency(details.total_earning_net || details.final_balance_net);

            const formatNumber = (value, options = {}) => {
                const number = Number(value);
                if (Number.isNaN(number)) return '-';
                return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    ...options,
                }).format(number);
            };

            const formatCurrencyValue = number => {
                const formatted = formatNumber(number);
                if (formatted === '-') return formatted;
                if (!currencyInfo.symbol) return formatted;
                return currencyInfo.position === 'prefix'
                    ? `${currencyInfo.symbol}${formatted}`
                    : `${formatted}${currencyInfo.symbol}`;
            };

            const parseNumeric = raw => {
                if (typeof raw === 'number') return raw;
                if (!raw) return 0;
                const sanitised = String(raw).replace(/[^\d\-.,]/g, '').replace(/,/g, '');
                const parsed = Number.parseFloat(sanitised);
                return Number.isNaN(parsed) ? 0 : parsed;
            };

            const formatIsoDate = iso => {
                if (!iso) return '-';
                const date = new Date(`${iso}T00:00:00`);
                if (Number.isNaN(date.getTime())) return iso;
                return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                }).format(date);
            };

            const badge = (text, tone = 'slate') => {
                const pageLocale = (document.documentElement.lang || navigator.language || 'en-US');
                const toUpperForLocale = (str) => {
                    if (!str) return '';
                    return pageLocale.toLowerCase().startsWith('tr')
                        ? str.toLocaleUpperCase('tr-TR')
                        : str.toLocaleUpperCase('en-US');
                };
                const tones = {
                    slate: 'border border-slate-200 bg-slate-100 text-slate-700',
                    green: 'border border-emerald-200 bg-emerald-50 text-gray-500',
                    blue: 'border border-sky-200 bg-sky-50 text-sky-700',
                    amber: 'border border-amber-200 bg-amber-50 text-amber-700',
                    indigo: 'border border-brand-accent bg-white text-brand-primary',
                };
                return `<span class="inline-flex items-center gap-1.5 px-3 py-1 text-[11px] font-semibold rounded-full ${tones[tone] || tones.slate}">${toUpperForLocale(text)}</span>`;
            };

            const toneClasses = {
                slate: 'bg-slate-50 border-slate-200 text-slate-800',
                success: 'bg-emerald-50 border-emerald-200 text-gray-500',
                info: 'bg-sky-50 border-sky-200 text-sky-700',
                brand: 'bg-white border-brand-accent text-brand-primary',
                warning: 'bg-amber-50 border-amber-200 text-amber-700',
                danger: 'bg-rose-50 border-rose-200 text-rose-700',
            };

            const statCard = (label, value, tone = 'slate', helper = '') => `
                <div class="rounded-2xl border px-4 py-4 shadow-sm ${toneClasses[tone] || toneClasses.slate}">
                    <div class="text-[11px] font-semibold uppercase tracking-wide opacity-90">${label}</div>
                    <div class="text-xl font-bold mt-2">${value ?? '-'}</div>
                    ${helper ? `<p class="text-[11px] mt-2 opacity-80 leading-snug">${helper}</p>` : ''}
                </div>
            `;

            const infoCard = (label, value) => `
                <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3">
                    <div class="text-[11px] uppercase tracking-wide text-slate-500">${label}</div>
                    <div class="text-base font-semibold text-slate-900 mt-2">${value ?? '-'}</div>
                </div>
            `;

            const row = (label, value, strong = false, extraClass = '') => `
                <div class="flex items-start justify-between gap-6 py-1.5 ${extraClass}">
                    <span class="text-sm font-medium text-slate-500">${label}</span>
                    <span class="${strong ? 'text-sm font-semibold text-slate-900' : 'text-sm text-slate-900'}">${value ?? '-'}</span>
                </div>
            `;

            const kvGrid = rowsHtml => `
                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
                    ${rowsHtml}
                </div>
            `;

            const section = (title, content, description = '') => `
                <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
                    <header class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-4">
                        <div>
                            <h4 class="text-xs font-semibold uppercase tracking-wide text-slate-500">${title}</h4>
                            ${description ? `<p class="text-[12px] text-slate-500 mt-1">${description}</p>` : ''}
                        </div>
                    </header>
                    ${content}
                </section>
            `;

            const renderDailyPostings = postingsObj => {
                const entries = Object.entries(postingsObj || {});
                if (!entries.length) {
                    return `<div class="text-xs text-slate-500 italic">${trans.noDailyPostings || 'No daily postings.'}</div>`;
                }

                entries.sort((a, b) => a[0].localeCompare(b[0]));

                const summary = entries.reduce(
                    (acc, [date, value]) => {
                        const amount = parseNumeric(value);
                        acc.total += amount;
                        if (amount > acc.largest.amount) {
                            acc.largest = { amount, raw: value, date };
                        }
                        return acc;
                    },
                    {
                        total: 0,
                        largest: { amount: parseNumeric(entries[0][1]), raw: entries[0][1], date: entries[0][0] },
                    },
                );

                const MAX_ROWS = 12;
                const head = `
                    <thead class="text-xs text-slate-500 bg-slate-50">
                        <tr>
                            <th class="text-left py-2.5 pl-4 pr-3 font-medium uppercase tracking-wide">${trans.date || 'Date'}</th>
                            <th class="text-right py-2.5 pr-4 pl-3 font-medium uppercase tracking-wide">${trans.netPosting || 'Net posting'}</th>
                        </tr>
                    </thead>
                `;

                const bodyRow = ([date, value], index) => `
                    <tr class="${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/40'} border-t border-slate-100">
                        <td class="py-2.5 pl-4 pr-3 text-sm text-slate-700">${formatIsoDate(date)}</td>
                        <td class="py-2.5 pr-4 pl-3 text-right text-sm font-semibold text-slate-900">${value}</td>
                    </tr>
                `;

                const first = entries.slice(0, MAX_ROWS).map(bodyRow).join('');
                const rest = entries.slice(MAX_ROWS).map((entry, idx) => bodyRow(entry, MAX_ROWS + idx)).join('');
                const hasMore = entries.length > MAX_ROWS;

                const insights = `
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 mb-4">
                        ${infoCard(trans.totalPostedLabel, formatCurrencyValue(summary.total))}
                        ${infoCard(trans.postingCountLabel, entries.length)}
                        ${infoCard(trans.firstPostingLabel, formatIsoDate(entries[0][0]))}
                        ${infoCard(trans.lastPostingLabel, formatIsoDate(entries[entries.length - 1][0]))}
                        ${infoCard(trans.largestPostingLabel, summary.largest ? `${formatCurrencyValue(summary.largest.amount)} · ${formatIsoDate(summary.largest.date)}` : '-')}
                    </div>
                `;

                return `
                    ${insights}
                    <div class="rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
                        <table class="w-full text-sm">
                            ${head}
                            <tbody>${first}</tbody>
                            ${hasMore ? `<tbody id="postings-extra" class="hidden">${rest}</tbody>` : ''}
                        </table>
                    </div>
                    ${
                        hasMore
                            ? `
                        <div class="mt-3 text-right">
                            <button id="toggle-postings" type="button" class="inline-flex items-center gap-2 text-xs font-semibold text-brand-primary hover:underline">
                                <span>${trans.showAll || 'Show all'}</span>
                            </button>
                        </div>
                    `
                            : ''
                    }
                `;
            };

            const compactChips = () => {
                const chips = [];
                if (details.is_custom) {
                    chips.push(badge(trans.customRateBadge || 'Custom rate', 'amber'));
                }
                // Removed bank offer badge as requested
                return chips.join(' ');
            };

            dom.modalTitle.textContent = `${details.bank_name} — ${details.account_name || ''}`.trim();
            const subtitleEl = document.getElementById('details-subtitle');
            if (subtitleEl) {
                const subtitleHtml = compactChips();
                subtitleEl.innerHTML = subtitleHtml;
                subtitleEl.classList.toggle('hidden', !subtitleHtml);
            }

            // Apply bank color as a subtle top border accent and to primary action
            const bankColor = (details.bank_color && typeof details.bank_color === 'string' && details.bank_color.trim()) || '#2e1818';
            const modalContent = document.getElementById('details-modal-content');
            if (modalContent) {
                modalContent.style.borderTop = `4px solid ${bankColor}`;
            }
            const headerEl = document.querySelector('#details-modal .modal-header');
            if (headerEl) {
                headerEl.style.backgroundColor = '#ffffff';
                headerEl.classList.add('shadow-sm');
            }

            const heroSection = '';

            const postingsSimple = (() => {
                const entries = Object.entries(details.daily_postings || {});
                if (!entries.length) return `<div class="text-xs text-slate-500 italic">${trans.noDailyPostings || 'No daily postings.'}</div>`;
                entries.sort((a, b) => a[0].localeCompare(b[0]));
                const items = entries.map(([date, value]) => {
                    const formattedDate = formatIsoDate(date);
                    const amount = formatCurrencyValue(parseNumeric(value));
                    return `
                        <div class="rounded-xl border border-slate-200 bg-white p-3 flex items-center justify-between hover:shadow-sm transition-shadow">
                            <span class="text-sm text-slate-700">${formattedDate}</span>
                            <span class="inline-flex items-center px-2.5 py-1 text-[12px] font-semibold rounded-full border" style="background-color:${bankColor}15; color:${bankColor}; border-color:${bankColor}33;">${amount}</span>
                        </div>
                    `;
                }).join('');
                return `<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">${items}</div>`;
            })();

            // Check if this is a BONO account (from account_name or product name)
            const accountName = details.account_name || '';
            const isBonoAccount = accountName.toLowerCase().includes('bono');
            const taxRate = isBonoAccount ? '15%' : 
                           (details.currency_code === 'TRY' ? '17.5%' : '25%');

            const snapshotRow = (label, value, emphasize = false, tone = 'normal') => {
                const valueToneClass = tone === 'tax'
                    ? 'text-rose-700'
                    : tone === 'net'
                        ? 'text-emerald-700'
                        : 'text-slate-900';
                return `
                    <div class="flex items-center justify-between gap-4 py-2">
                        <span class="text-[12px] font-medium uppercase tracking-wide text-slate-600">${label}</span>
                        <span class="${emphasize ? 'text-lg font-bold' : 'text-sm font-semibold'} ${valueToneClass}">${value ?? '-'}</span>
                    </div>
                `;
            };

            const snapshotCard = (title, rows) => `
                <div class="rounded-xl border bg-white overflow-hidden" style="border-color:${bankColor}33;">
                    <div class="px-4 py-2.5 border-b text-xs font-semibold uppercase tracking-wide" style="color:${bankColor}; border-color:${bankColor}22; background-color:${bankColor}08;">
                        ${title}
                    </div>
                    <div class="px-4 py-3 divide-y divide-slate-100">
                        ${rows}
                    </div>
                </div>
            `;

            const overviewRows = [
                snapshotRow(trans.principalLabel, details.principal),
                snapshotRow(trans.startDateLabel, details.start_date ? formatIsoDate(details.start_date) : '-'),
                snapshotRow(trans.durationLabel, details.duration),
                snapshotRow(trans.finalBalanceLabel, `${details.final_balance_net}`, true),
            ].join('');

            const earningsRows = [
                snapshotRow(trans.grossEarningLabel, details.total_earning_gross),
                snapshotRow(trans.withholdingLabel, `${details.withholding_tax_amount}`, false, 'tax'),
                snapshotRow(trans.netEarningLabel, details.total_earning_net, true, 'net'),
            ].join('');

            const ratesRows = [
                snapshotRow(trans.annualRateLabel, details.gross_annual_rate),
                snapshotRow(trans.withholdingRateLabel || 'Withholding tax rate', taxRate, false, 'tax'),
                snapshotRow(trans.netRateLabel, details.real_annual_rate, true, 'net'),
            ].join('');

            const snapshotContent = `
                <div class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
                    <div class="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
                        <h4 class="text-sm font-semibold" style="color: ${bankColor};">${trans.calcSnapshotLabel}</h4>
                        <span class="inline-flex items-center text-[11px] font-semibold px-2.5 py-1 rounded-full" style="background-color: ${bankColor}15; color: ${bankColor};">${details.currency_code}</span>
                    </div>
                    <div class="p-5 grid grid-cols-1 md:grid-cols-3 gap-4">
                        ${snapshotCard(trans.overview || 'Overview', overviewRows)}
                        ${snapshotCard(trans.earnings || 'Earnings', earningsRows)}
                        ${snapshotCard(trans.netAnnualRate || 'Rates', ratesRows)}
                    </div>
                </div>
            `;


            const projections = '';

            const postings = `
                <div class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
                    <div class="px-5 py-4 border-b border-gray-100">
                        <h4 class="text-sm font-semibold" style="color: ${bankColor};">${trans.dailyPostings || 'Daily Postings'}</h4>
                    </div>
                    <div class="p-5">
                        ${postingsSimple}
                    </div>
                </div>
            `;

            const viewBtnDisabled = !details.detail_url || details.is_custom;
            const viewBtnStyle = viewBtnDisabled ? '' : `style="background-color:${bankColor};"`;

            dom.modalBody.innerHTML = `
                <div class="space-y-6 max-w-4xl w-full mx-auto">
                    <div class="rounded-2xl border border-slate-200 bg-white p-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3" style="border-left: 4px solid ${bankColor};">
                        <div>
                            <div class="text-xs font-semibold uppercase tracking-wide text-slate-500">${trans.calcSnapshotLabel}</div>
                        </div>
                        <div class="flex flex-wrap gap-2">
                            <button
                                id="details-copy-btn"
                                type="button"
                                class="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:border-brand-accent hover:text-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-accent disabled:opacity-60"
                                data-default-label="${trans.copySummaryLabel}"
                                data-success-label="${trans.copiedLabel}"
                                data-error-label="${trans.copyErrorLabel}"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="1.5"></rect>
                                    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke-width="1.5"></path>
                                </svg>
                                <span>${trans.copySummaryLabel}</span>
                            </button>
                            <button
                                id="details-view-offer"
                                type="button"
                                class="inline-flex items-center gap-2 rounded-xl px-5 py-2 text-sm font-semibold text-white transition-colors ${viewBtnDisabled ? 'bg-slate-400 cursor-not-allowed' : ''}"
                                ${viewBtnDisabled ? `disabled title="${trans.viewDetailsDisabled}"` : viewBtnStyle}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5l7 7-7 7" />
                                </svg>
                                <span>${trans.viewDetailsLabel}</span>
                            </button>
                        </div>
                    </div>
                    ${snapshotContent}
                    ${postings}
                </div>
            `;

            const toggleBtn = document.getElementById('toggle-postings');
            if (toggleBtn) {
                toggleBtn.addEventListener('click', () => {
                    const extra = document.getElementById('postings-extra');
                    if (!extra) return;
                    const isHidden = extra.classList.contains('hidden');
                    extra.classList.toggle('hidden', !isHidden);
                    const label = toggleBtn.querySelector('span');
                    if (label) {
                        label.textContent = isHidden ? (trans.showLess || 'Show less') : (trans.showAll || 'Show all');
                    }
                });
            }

            const copyBtn = document.getElementById('details-copy-btn');
            if (copyBtn) {
                copyBtn.addEventListener('click', async () => {
                    const lines = [
                        dom.modalTitle.textContent,
                        '',
                        // Group 1: Principal, Duration, Final Balance
                        `${trans.principalLabel}: ${details.principal}`,
                        `${trans.startDateLabel}: ${details.start_date ? formatIsoDate(details.start_date) : '-'}`,
                        `${trans.durationLabel}: ${details.duration}`,
                        `${trans.finalBalanceLabel}: ${details.final_balance_net}`,
                        '',
                        // Group 2: Annual Rate, Withholding Tax Rate, Net Rate
                        `${trans.annualRateLabel}: ${details.gross_annual_rate}`,
                        `${trans.withholdingRateLabel || 'Withholding tax rate'}: ${taxRate}`,
                        `${trans.netRateLabel}: ${details.real_annual_rate}`,
                        '',
                        // Group 3: Gross Earning, Withholding Tax, Net Earning
                        `${trans.grossEarningLabel}: ${details.total_earning_gross}`,
                        `${trans.withholdingLabel}: ${details.withholding_tax_amount}`,
                        `${trans.netEarningLabel}: ${details.total_earning_net}`,
                        '',
                        '',
                        (() => {
                            const lang = (document.documentElement.lang || '').toLowerCase();
                            if (lang.startsWith('tr')) return 'Günlük Kazançlar';
                            return trans.dailyPostings || 'Daily Postings';
                        })(),
                        '',
                        ...(() => {
                            const entries = Object.entries(details.daily_postings || {});
                            if (!entries.length) return [];
                            entries.sort((a, b) => a[0].localeCompare(b[0]));
                            const rows = entries.map(([date, value]) => [formatIsoDate(date), formatCurrencyValue(parseNumeric(value))]);
                            const maxDateLen = rows.reduce((m, [d]) => Math.max(m, (d || '').length), 0);
                            return rows.map(([d, a]) => `${String(d).padEnd(maxDateLen, ' ')}  —  ${a}`);
                        })(),
                    ].filter(v => v !== undefined && v !== null).join('\n');

                    const label = copyBtn.querySelector('span');
                    const reset = () => {
                        copyBtn.disabled = false;
                        if (label) {
                            label.textContent = copyBtn.dataset.defaultLabel || trans.copySummaryLabel;
                        }
                    };

                    try {
                        copyBtn.disabled = true;
                        if (navigator.clipboard && navigator.clipboard.writeText) {
                            await navigator.clipboard.writeText(lines);
                        } else {
                            const textarea = document.createElement('textarea');
                            textarea.value = lines;
                            textarea.setAttribute('readonly', '');
                            textarea.style.position = 'absolute';
                            textarea.style.left = '-9999px';
                            document.body.appendChild(textarea);
                            textarea.select();
                            document.execCommand('copy');
                            document.body.removeChild(textarea);
                        }
                        if (label) {
                            label.textContent = copyBtn.dataset.successLabel || trans.copiedLabel;
                        }
                        setTimeout(reset, 2000);
                    } catch (error) {
                        if (label) {
                            label.textContent = copyBtn.dataset.errorLabel || trans.copyErrorLabel;
                        }
                        setTimeout(reset, 2000);
                    }
                });
            }

            const viewBtn = document.getElementById('details-view-offer');
            if (viewBtn) {
                const bankColor = (details.bank_color && typeof details.bank_color === 'string' && details.bank_color.trim()) || '#2e1818';
                if (!viewBtnDisabled) {
                    viewBtn.style.backgroundColor = bankColor;
                    viewBtn.classList.add('hover:bg-opacity-90', 'focus:ring-2', 'focus:ring-offset-1');
                }
            }
            if (viewBtn && !viewBtnDisabled && details.detail_url) {
                viewBtn.addEventListener('click', () => {
                    window.location.assign(normalizeDailyDepositDetailUrl(details.detail_url));
                });
            }

            // Make copy summary button hover use bank color instead of brand color
            const copyBtnHover = document.getElementById('details-copy-btn');
            if (copyBtnHover) {
                const bankColor = (details.bank_color && typeof details.bank_color === 'string' && details.bank_color.trim()) || '#2e1818';
                // Remove brand accent hover/focus classes if present
                copyBtnHover.classList.remove('hover:border-brand-accent', 'hover:text-brand-primary', 'focus:ring-brand-accent');
                copyBtnHover.addEventListener('mouseenter', () => {
                    copyBtnHover.style.borderColor = bankColor;
                    copyBtnHover.style.color = bankColor;
                });
                copyBtnHover.addEventListener('mouseleave', () => {
                    copyBtnHover.style.borderColor = '';
                    copyBtnHover.style.color = '';
                });
                copyBtnHover.addEventListener('focus', () => {
                    copyBtnHover.style.borderColor = bankColor;
                    copyBtnHover.style.color = bankColor;
                });
                copyBtnHover.addEventListener('blur', () => {
                    copyBtnHover.style.borderColor = '';
                    copyBtnHover.style.color = '';
                });
                // Active/click feedback using bank color
                copyBtnHover.addEventListener('mousedown', () => {
                    copyBtnHover.style.backgroundColor = bankColor + '10';
                    copyBtnHover.style.borderColor = bankColor;
                    copyBtnHover.style.color = bankColor;
                });
                copyBtnHover.addEventListener('mouseup', () => {
                    copyBtnHover.style.backgroundColor = '';
                });
            }

            modals.details.show();
        }


        const buildDetailCacheKey = offerId => {
            if (!state.lastCalculationPayload) return String(offerId);
            const { amount, duration, currency, days_cumulative } = state.lastCalculationPayload;
            return [offerId, amount, duration, getSelectedStartDate(), currency, days_cumulative ? 1 : 0].join('|');
        };

        async function fetchOfferDetail(offerId, detailUrl) {
            if (!detailUrl) {
                throw new Error(trans.unknownError);
            }
            if (!state.lastCalculationPayload) {
                throw new Error(trans.unknownError);
            }

            const cacheKey = buildDetailCacheKey(offerId);
            if (detailCache.has(cacheKey)) {
                return detailCache.get(cacheKey);
            }

            const payload = {
                amount: state.lastCalculationPayload.amount,
                duration: state.lastCalculationPayload.duration,
                start_date: getSelectedStartDate(),
                currency: state.lastCalculationPayload.currency,
                days_cumulative: state.lastCalculationPayload.days_cumulative,
            };

            if (state.lastCalculationPayload.custom_rate) {
                payload.custom_rate = state.lastCalculationPayload.custom_rate;
            }
            if (state.lastCalculationPayload.custom_rates) {
                payload.custom_rates = state.lastCalculationPayload.custom_rates;
            }

            const response = await fetch(detailUrl, {
                method: 'POST',
                headers: buildJsonHeaders(),
                body: JSON.stringify(payload),
            });

            const contentType = response.headers.get('content-type') || '';
            let data;
            if (contentType.includes('application/json')) {
                data = await response.json();
            } else {
                const text = await response.text();
                throw new Error(`${trans.unknownError} (${response.status})`);
            }

            if (!response.ok || !data || !data.success) {
                throw new Error(getApiErrorMessage(data, trans.unknownError));
            }

            if (!data.result) {
                throw new Error(trans.unknownError);
            }

            detailCache.set(cacheKey, data.result);
            return data.result;
        }


        function updateRelativeTimes() {
            $$('.relative-time[data-update-date]').forEach(element => {
                const isoDate = element.dataset.updateDate;
                if (!isoDate) {
                    element.textContent = '';
                    return;
                }

                const updateDate = new Date(isoDate);
                const formatted = formatRelativeUpdate(updateDate);
                element.textContent = formatted || '-';
            });
        }

        function updateCurrencyScrollButtons() {
            const container = document.getElementById('currency-filter-container');
            const scrollLeftBtn = document.getElementById('currency-scroll-left');
            const scrollRightBtn = document.getElementById('currency-scroll-right');
            
            if (!container || !scrollLeftBtn || !scrollRightBtn) return;
            
            const updateButtons = () => {
                const scrollLeft = container.scrollLeft;
                const scrollWidth = container.scrollWidth;
                const clientWidth = container.clientWidth;
                const canScrollLeft = scrollLeft > 0;
                const canScrollRight = scrollLeft < (scrollWidth - clientWidth - 1);
                
                scrollLeftBtn.disabled = !canScrollLeft;
                scrollRightBtn.disabled = !canScrollRight;
                
                if (scrollWidth > clientWidth) {
                    scrollLeftBtn.classList.remove('hidden');
                    scrollRightBtn.classList.remove('hidden');
                } else {
                    scrollLeftBtn.classList.add('hidden');
                    scrollRightBtn.classList.add('hidden');
                }
            };
            
            container.addEventListener('scroll', updateButtons);
            window.addEventListener('resize', updateButtons);
            updateButtons();
            
            scrollLeftBtn.addEventListener('click', () => {
                container.scrollBy({ left: -200, behavior: 'smooth' });
            });
            
            scrollRightBtn.addEventListener('click', () => {
                container.scrollBy({ left: 200, behavior: 'smooth' });
            });
        }
        
        // Currency button event listeners are attached in renderCurrencyButtons()
        // after buttons are dynamically created
        
        updateCurrencyScrollButtons();
        
        // Handle tax warning close button
        const taxWarningCloseBtn = document.getElementById('tax-warning-close');
        if (taxWarningCloseBtn) {
            taxWarningCloseBtn.addEventListener('click', function() {
                const taxWarningBox = document.getElementById('tax-warning-box');
                if (taxWarningBox) {
                    // Store closed state for current currency only
                    const currencyCode = state.currency || 'TRY';
                    const warningClosedKey = `tax-warning-closed-${currencyCode}`;
                    taxWarningBox.style.display = 'none';
                    localStorage.setItem(warningClosedKey, 'true');
                }
            });
        }

        if (dom.settingsButton && modals.settings) {
            dom.settingsButton.addEventListener('click', () => {
                syncFilterCheckboxes();
                syncAssetCheckboxes();
                modals.settings.show();
            });
        }
        if (dom.settingsClose && modals.settings) {
            dom.settingsClose.addEventListener('click', () => modals.settings.hide());
        }
        if (dom.settingsApply) dom.settingsApply.addEventListener('click', applySettings);
        if (dom.settingsClear) dom.settingsClear.addEventListener('click', clearSettings);

        if (dom.disclaimerButton) {
            dom.disclaimerButton.addEventListener('click', performCalculation);
        }
        if (dom.clearCalculationButton) {
            dom.clearCalculationButton.addEventListener('click', clearCalculation);
        }
        if (dom.disclaimerClose && modals.disclaimer) {
            dom.disclaimerClose.addEventListener('click', () => modals.disclaimer.hide());
        }
        if (dom.disclaimerCancel && modals.disclaimer) {
            dom.disclaimerCancel.addEventListener('click', () => modals.disclaimer.hide());
        }
        if (dom.disclaimerAccept) dom.disclaimerAccept.addEventListener('click', performCalculation);

        if (dom.detailsClose && modals.details) {
            dom.detailsClose.addEventListener('click', () => modals.details.hide());
        }
        async function handleCalculationResultClick(event) {
            const trigger = event.target.closest('.calculation-result-btn');
            if (!trigger) return;

            const detailUrl = trigger.dataset.detailUrl;
            const offerId =
                trigger.dataset.detailOfferId
                || (trigger.closest('.account-card') || {}).dataset?.offerId;
            const fallbackUrl = normalizeDailyDepositDetailUrl(trigger.dataset.detailPageUrl);

            const inlineDetails = trigger.dataset.details;
            if (!detailUrl && inlineDetails) {
                try {
                    const parsed = JSON.parse(inlineDetails);
                    showDetails(parsed);
                } catch (e) {
                    showCalculatorError(`${trans.error}: ${e.message}`);
                }
                return;
            }

            if (!detailUrl) {
                if (fallbackUrl) {
                    window.location.assign(fallbackUrl);
                }
                return;
            }

            if (!offerId) {
                return;
            }

            try {
                trigger.disabled = true;
                trigger.classList.add('opacity-60');
                const detail = await fetchOfferDetail(offerId, detailUrl);
                if (detail) {
                    showDetails(detail);
                }
            } catch (error) {
                if (fallbackUrl) {
                    window.location.assign(fallbackUrl);
                } else {
                    showCalculatorError(`${trans.error}: ${error.message}`);
                }
            } finally {
                trigger.disabled = false;
                trigger.classList.remove('opacity-60');
            }
        }

        [dom.grid, dom.staleGrid]
            .filter(Boolean)
            .forEach(grid => {
                grid.addEventListener('click', handleCalculationResultClick);
            });

        if (dom.bankFilterButton && modals.bankFilter) {
            dom.bankFilterButton.addEventListener('click', openBankFilterModal);
        }
        if (dom.bankFilterClose && modals.bankFilter) {
            dom.bankFilterClose.addEventListener('click', closeBankFilterModal);
        }
        if (dom.bankFilterSelectAll) {
            dom.bankFilterSelectAll.addEventListener('click', () => {
                bankCheckboxes.forEach(checkbox => {
                    checkbox.checked = true;
                });
            });
        }
        if (dom.bankFilterDeselectAll) {
            dom.bankFilterDeselectAll.addEventListener('click', () => {
                bankCheckboxes.forEach(checkbox => {
                    checkbox.checked = false;
                });
            });
        }
        if (dom.bankFilterApply) {
            dom.bankFilterApply.addEventListener('click', () => {
                applyBankSelectionFromModal();
                saveStateToStorage();
            });
        }
        if (dom.bankFilterClear) {
            dom.bankFilterClear.addEventListener('click', () => {
                state.selectedBanks = new Set();
                syncBankCheckboxes();
                updateBankFilterCount();
                updateFilterBadge();
                applyFilters();
                sortCardsByRate();
                saveStateToStorage();
                closeBankFilterModal();
            });
        }
        if (dom.bankFilterSearch) {
            dom.bankFilterSearch.addEventListener('input', event => filterBankList(event.target.value));
        }

        if (dom.customRateButton && modals.customRate) {
            dom.customRateButton.addEventListener('click', () => {
                hideCalculatorError();
                clearCustomRateInputs();
                if (state.customRate) {
                    addCustomRateRow(state.customRate);
                } else if (state.customRates && state.customRates.length) {
                    state.customRates.slice(0, 4).forEach(cr => addCustomRateRow(cr));
                } else {
                    addCustomRateRow();
                }
                rebuildCustomRateTabs(0);
                modals.customRate.show();
            });
        }
        if (dom.customRateAdd) {
            dom.customRateAdd.addEventListener('click', () => addCustomRateRow());
        }
        if (dom.customRateClose && modals.customRate) {
            dom.customRateClose.addEventListener('click', () => modals.customRate.hide());
        }
        if (dom.customRateApply) {
            dom.customRateApply.addEventListener('click', () => {
                hideCalculatorError();
                const items = [];
                const list = dom.customRateList;
                const rows = list ? Array.from(list.children) : [];
                rows.slice(0, 4).forEach((row, idx) => {
                    const inputs = row.querySelectorAll('input');
                    if (!inputs || inputs.length === 0) return;
                    const name = inputs[0] ? String(inputs[0].value || '').trim() : '';
                    const annual = inputs[1] ? Number(inputs[1].value) : NaN;
                    const passiveAmt = inputs[2] ? Number(inputs[2].value) : 0;
                    const passivePct = inputs[3] ? Number(inputs[3].value) : 0;
                    const weekend = inputs[4] ? !!inputs[4].checked : false;
                    if (!Number.isFinite(annual) || annual <= 0) return;
                    items.push({ name, rate: annual, passiveBalance: passiveAmt, passiveRate: passivePct, weekend });
                });
                if (!items.length) {
                    showCalculatorError(trans.customRateInvalid);
                    return;
                }
                if (items.length === 1) {
                    state.customRate = items[0];
                    state.customRates = [];
                } else {
                    state.customRate = null;
                    state.customRates = items;
                }
                updateCustomRateIndicator();
                if (modals.customRate) modals.customRate.hide();
                removeCustomCard();
                saveStateToStorage();
            });
        }
        if (dom.customRateClear) {
            dom.customRateClear.addEventListener('click', () => {
                state.customRate = null;
                state.customRates = [];
                updateCustomRateIndicator();
                removeCustomCard();
                clearCustomRateInputs();
                hideCalculatorError();
                if (modals.customRate) modals.customRate.hide();
                saveStateToStorage();
            });
        }
        // Initial render -----------------------------------------------------
        syncFilterCheckboxes();
        syncAssetCheckboxes();
        updateFilterBadge();
        updateCustomRateIndicator();
        loadCurrencies().then(() => {
            updateCurrencySymbol();
            syncCurrencyButtons();
        });
        loadBanks().then(() => {
            syncBankCheckboxes();
            updateBankFilterCount();
            filterBankList('');
        });
        loadOffers();
        loadMarketPerformance();
        loadStatistics();
    };


    document.addEventListener('DOMContentLoaded', init);
    if (document.readyState !== 'loading') {
        init();
    }
})();
